
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("7G5ZJ", function(module, exports) {

$parcel$export(module.exports, "Reactions", () => $06ab72918ff66fb4$export$44cd1c46d5ca2376);
/* Reactions.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $inPa6 = parcelRequire("inPa6");

var $6xdDU = parcelRequire("6xdDU");

var $hnvzE = parcelRequire("hnvzE");

var $jEwF8 = parcelRequire("jEwF8");

var $dEmEP = parcelRequire("dEmEP");

var $9G3wK = parcelRequire("9G3wK");

var $dyQ51 = parcelRequire("dyQ51");

var $1x5Ue = parcelRequire("1x5Ue");

var $3NvVh = parcelRequire("3NvVh");

var $fER6k = parcelRequire("fER6k");

var $8RXMv = parcelRequire("8RXMv");

var $4WjwD = parcelRequire("4WjwD");

var $95fI5 = parcelRequire("95fI5");

var $bedQP = parcelRequire("bedQP");
const $06ab72918ff66fb4$var$ReactionPicker = (0, $bedQP.componentWithFG)('platform_editor_reactions_picker_fix', (0, $4WjwD.ReactionPicker), (0, $8RXMv.ReactionPicker));
const $06ab72918ff66fb4$var$wrapperStyle = null;
const $06ab72918ff66fb4$var$noFlexWrapStyles = null;
const $06ab72918ff66fb4$var$noContainerPositionStyles = null;
const $06ab72918ff66fb4$var$reactionPickerStyle = null; /**
                                   * Set of all available UFO experiences relating to Reactions Dialog
                                   */ 
const $06ab72918ff66fb4$export$615f888019c45765 = {
    /**
   * Experience when a reaction dialog is opened
   */ openDialog: (0, $1x5Ue.ReactionDialogOpened),
    /**
   * Experience when a reaction changed/fetched from inside the modal dialog
   */ selectedReactionChangeInsideDialog: (0, $1x5Ue.ReactionDialogSelectedReactionChanged)
}; /**
    * Test id for wrapper Reactions div
    */ 
const $06ab72918ff66fb4$export$45beea5a8efd4cda = 'render-reactions'; /**
                                                            * Test id for the view all reacted user to trigger the dialog
                                                            */ 
const $06ab72918ff66fb4$export$6fd545f57ca8a08a = 'viewall-reacted-users-dialog'; /**
                                                                                    * Test id for summary view of reactions
                                                                                    */ 
const $06ab72918ff66fb4$export$23a875699bfce51b = 'reaction-summary-view';
function $06ab72918ff66fb4$export$46455b4476d4b8e1(status, errorMessage, tooltipContent) {
    switch(status){
        case (0, $dyQ51.ReactionStatus).error:
            return errorMessage || /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...(0, $9G3wK.messages).unexpectedError
            });
        // When reaction is not available don't show any tooltip (e.g. Archive page in Confluence)
        case (0, $dyQ51.ReactionStatus).disabled:
            return null;
        case (0, $dyQ51.ReactionStatus).notLoaded:
        case (0, $dyQ51.ReactionStatus).loading:
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...(0, $9G3wK.messages).loadingReactions
            });
        case (0, $dyQ51.ReactionStatus).ready:
            return !!tooltipContent ? tooltipContent : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...(0, $9G3wK.messages).addReaction
            });
    }
} /**
   * Renders list of reactions
   */ 
const $06ab72918ff66fb4$export$44cd1c46d5ca2376 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).memo(({ flash: flash = {}, particleEffectByEmoji: particleEffectByEmoji = {}, status: status, errorMessage: errorMessage, loadReaction: loadReaction, quickReactionEmojis: quickReactionEmojis, pickerQuickReactionEmojiIds: pickerQuickReactionEmojiIds, getReactionDetails: getReactionDetails = ()=>{}, onSelection: onSelection, reactions: reactions = [], emojiProvider: emojiProvider, allowAllEmojis: allowAllEmojis, onReactionClick: onReactionClick, allowUserDialog: allowUserDialog, onDialogOpenCallback: onDialogOpenCallback = ()=>{}, onDialogCloseCallback: onDialogCloseCallback = ()=>{}, onDialogSelectReactionCallback: onDialogSelectReactionCallback = ()=>{}, onDialogPageChangeCallback: onDialogPageChangeCallback = ()=>{}, emojiPickerSize: emojiPickerSize = 'medium', miniMode: miniMode = false, summaryViewEnabled: summaryViewEnabled = false, summaryViewThreshold: summaryViewThreshold = 3, summaryViewPlacement: summaryViewPlacement, showOpaqueBackground: showOpaqueBackground = false, subtleReactionsSummaryAndPicker: subtleReactionsSummaryAndPicker = false, showAddReactionText: showAddReactionText = false, hideDefaultReactions: hideDefaultReactions = false, ProfileCardWrapper: ProfileCardWrapper, onlyRenderPicker: onlyRenderPicker = false, isViewOnly: isViewOnly = false, noWrap: noWrap = false, noRelativeContainer: noRelativeContainer = false, showSubtleDefaultReactions: showSubtleDefaultReactions, reactionPickerTriggerTooltipContent: reactionPickerTriggerTooltipContent, reactionPickerTriggerIcon: reactionPickerTriggerIcon, allowSelectFromSummaryView: allowSelectFromSummaryView = false, useButtonAlignmentStyling: useButtonAlignmentStyling = false, reactionPickerTriggerText: reactionPickerTriggerText, hoverableSummaryView: hoverableSummaryView = false, isListItem: isListItem = false, summaryGetOptimisticImageURL: summaryGetOptimisticImageURL, reactionPickerPlacement: reactionPickerPlacement, summaryButtonIconAfter: summaryButtonIconAfter, renderParticleEffectOnSummaryView: renderParticleEffectOnSummaryView = false })=>{
    const [selectedEmojiId, setSelectedEmojiId] = (0, $gwFzn.useState)('');
    const [summaryViewParticleEffectEmojiId, setSummaryViewParticleEffectEmojiId] = (0, $gwFzn.useState)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let openTime = (0, $gwFzn.useRef)();
    let renderTime = (0, $gwFzn.useRef)();
    (0, $gwFzn.useEffect)(()=>{
        if (status === (0, $dyQ51.ReactionStatus).notLoaded) loadReaction();
    }, [
        status,
        loadReaction
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (status !== (0, $dyQ51.ReactionStatus).ready) renderTime.current = Date.now();
        else {
            const isSSR = undefined;
            if ((0, $jEwF8.isSampled)((0, $dEmEP.SAMPLING_RATE_REACTIONS_RENDERED_EXP)) && !isSSR) (0, $jEwF8.createAndFireSafe)(createAnalyticsEvent, (0, $jEwF8.createReactionsRenderedEvent), renderTime.current ?? Date.now() //renderTime.current can be null during unit test cases
            );
            renderTime.current = undefined;
        }
    }, [
        createAnalyticsEvent,
        status
    ]);
    const handleReactionMouseEnter = (0, $gwFzn.useCallback)((emojiId)=>{
        getReactionDetails(emojiId);
    }, [
        getReactionDetails
    ]);
    const handleReactionFocused = (0, $gwFzn.useCallback)((emojiId)=>{
        getReactionDetails(emojiId);
    }, [
        getReactionDetails
    ]);
    const handlePickerOpen = (0, $gwFzn.useCallback)(()=>{
        openTime.current = Date.now();
        (0, $jEwF8.createAndFireSafe)(createAnalyticsEvent, (0, $jEwF8.createPickerButtonClickedEvent), reactions.length);
    }, [
        createAnalyticsEvent,
        reactions
    ]);
    const handleOnCancel = (0, $gwFzn.useCallback)(()=>{
        (0, $jEwF8.createAndFireSafe)(createAnalyticsEvent, (0, $jEwF8.createPickerCancelledEvent), openTime.current);
        openTime.current = undefined;
    }, [
        createAnalyticsEvent
    ]);
    const handleOnMore = (0, $gwFzn.useCallback)(()=>{
        (0, $jEwF8.createAndFireSafe)(createAnalyticsEvent, (0, $jEwF8.createPickerMoreClickedEvent), openTime.current);
    }, [
        createAnalyticsEvent
    ]);
    const handleSetSummaryViewParticleEffectEmojiId = (0, $gwFzn.useCallback)((emojiId)=>{
        // Find if this emoji is already in existing reactions
        const existingReaction = reactions.find((reaction)=>reaction.emojiId === emojiId); // Only set mostRecentlyClickedId if user hasn't reacted with this emoji yet
        if (!existingReaction?.reacted) setSummaryViewParticleEffectEmojiId({
            id: emojiId,
            shortName: ''
        });
        else setSummaryViewParticleEffectEmojiId(null);
    }, [
        reactions,
        setSummaryViewParticleEffectEmojiId
    ]);
    const handleOnSelection = (0, $gwFzn.useCallback)((emojiId, source)=>{
        (0, $jEwF8.createAndFireSafe)(createAnalyticsEvent, (0, $jEwF8.createReactionSelectionEvent), source, emojiId, reactions.find((reaction)=>reaction.emojiId === emojiId), openTime.current);
        openTime.current = undefined;
        onSelection(emojiId);
        handleSetSummaryViewParticleEffectEmojiId(emojiId);
    }, [
        createAnalyticsEvent,
        onSelection,
        reactions,
        handleSetSummaryViewParticleEffectEmojiId
    ]);
    const handleSummaryViewReactionClick = (0, $gwFzn.useCallback)((emojiId, event)=>{
        onReactionClick(emojiId, event);
        handleSetSummaryViewParticleEffectEmojiId(emojiId);
    }, [
        onReactionClick,
        handleSetSummaryViewParticleEffectEmojiId
    ]);
    const handleCloseReactionsDialog = (e, analyticsEvent)=>{
        setSelectedEmojiId('');
        onDialogCloseCallback(e, analyticsEvent);
    };
    const handleSelectReactionInDialog = (emojiId)=>{
        // ufo selected reaction inside the modal dialog
        $06ab72918ff66fb4$export$615f888019c45765.selectedReactionChangeInsideDialog.start();
        handleReactionMouseEnter(emojiId);
        setSelectedEmojiId(emojiId);
        onDialogSelectReactionCallback(emojiId); // ufo selected reaction inside the modal dialog success
        $06ab72918ff66fb4$export$615f888019c45765.selectedReactionChangeInsideDialog.success({
            metadata: {
                emojiId: emojiId,
                source: 'Reactions',
                reason: 'Selected Emoji changed'
            }
        });
    };
    const handlePaginationChange = (0, $gwFzn.useCallback)((emojiId, currentPage, maxPages)=>{
        // fetch the latest active emoji from the new page
        getReactionDetails(emojiId);
        setSelectedEmojiId(emojiId);
        onDialogPageChangeCallback(emojiId, currentPage, maxPages);
    }, // Exclude unstable getReactionDetails to avoid extra re-renders
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        setSelectedEmojiId
    ]); /**
                          * Get the reactions that we want to render are any reactions with a count greater than zero as well as any default emoji not already shown
                          */ 
    const memorizedReactions = (0, $gwFzn.useMemo)(()=>{
        //
        /**
     * If reactions not empty, don't show quick reactions Pre defined emoji or if its empty and default reactions not hidden => return the current list of reactions
     */ if (reactions.length === 0 && hideDefaultReactions || reactions.length > 0 || !quickReactionEmojis) return reactions;
         // add any missing default reactions
        const { ari: ari, containerAri: containerAri, emojiIds: emojiIds } = quickReactionEmojis;
        const items = emojiIds.filter((emojiId)=>!reactions.some((reaction)=>reaction.emojiId === emojiId)).map((emojiId)=>{
            return {
                ari: ari,
                containerAri: containerAri,
                emojiId: emojiId,
                count: 0,
                reacted: false
            };
        });
        return reactions.concat(items);
    }, [
        quickReactionEmojis,
        reactions,
        hideDefaultReactions
    ]);
    const shouldShowSummaryView = summaryViewEnabled && memorizedReactions.length >= summaryViewThreshold && reactions.length > 0; // criteria to show Reactions Dialog
    const hasEmojiWithFivePlusReactions = reactions.some((reaction)=>reaction.count >= 5);
    const sortedReactions = (0, $gwFzn.useMemo)(()=>{
        return [
            ...memorizedReactions
        ].sort((a, b)=>b?.count - a?.count);
    }, [
        memorizedReactions
    ]); /**
                             * event handler to open dialog with selected reaction
                             * @param emojiId initial emoji id to load dialog with
                             */ 
    const handleOpenReactionsDialog = ({ emojiId: emojiId = sortedReactions[0].emojiId, source: source = 'endOfPageReactions' } = {})=>{
        // ufo start opening reaction dialog
        $06ab72918ff66fb4$export$615f888019c45765.openDialog.start();
        getReactionDetails(emojiId);
        setSelectedEmojiId(emojiId);
        onDialogOpenCallback(emojiId, source); // ufo opening reaction dialog success
        $06ab72918ff66fb4$export$615f888019c45765.openDialog.success({
            metadata: {
                emojiId: emojiId,
                source: 'Reactions',
                reason: 'Opening Reactions Dialog successfully'
            }
        });
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hnvzE.default), {
        name: "reactions",
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)("div", {
            "data-testid": $06ab72918ff66fb4$export$45beea5a8efd4cda,
            className: (0, $35pXk.default)([
                "_2rkoo7ao _1e0c1txw _1n261g80 _kqswh2mm _4cvr1h6o _19pkr5cr _13vtidpf",
                noWrap && "_1n261q9c",
                noRelativeContainer && "_kqswpfqs"
            ]),
            children: [
                !onlyRenderPicker && (shouldShowSummaryView ? /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                    "data-testid": $06ab72918ff66fb4$export$23a875699bfce51b,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $95fI5.ReactionSummaryView), {
                        reactions: sortedReactions,
                        emojiProvider: emojiProvider,
                        flash: flash,
                        particleEffectByEmoji: particleEffectByEmoji,
                        onSelection: handleOnSelection,
                        onReactionClick: handleSummaryViewReactionClick,
                        onReactionFocused: handleReactionFocused,
                        onReactionMouseEnter: handleReactionMouseEnter,
                        placement: summaryViewPlacement,
                        showOpaqueBackground: showOpaqueBackground,
                        subtleReactionsSummaryAndPicker: subtleReactionsSummaryAndPicker,
                        handleOpenReactionsDialog: ()=>handleOpenReactionsDialog({
                                source: 'summaryView'
                            }),
                        allowUserDialog: allowUserDialog && hasEmojiWithFivePlusReactions,
                        isViewOnly: isViewOnly,
                        allowSelectFromSummaryView: allowSelectFromSummaryView,
                        disabled: status !== (0, $dyQ51.ReactionStatus).ready,
                        reactionPickerTriggerIcon: reactionPickerTriggerIcon,
                        tooltipContent: $06ab72918ff66fb4$export$46455b4476d4b8e1(status, errorMessage, reactionPickerTriggerTooltipContent),
                        emojiPickerSize: emojiPickerSize,
                        onOpen: handlePickerOpen,
                        useButtonAlignmentStyling: useButtonAlignmentStyling,
                        reactionPickerTriggerText: reactionPickerTriggerText,
                        hoverableSummaryView: hoverableSummaryView,
                        summaryGetOptimisticImageURL: summaryGetOptimisticImageURL,
                        summaryButtonIconAfter: summaryButtonIconAfter,
                        summaryViewParticleEffectEmojiId: renderParticleEffectOnSummaryView ? summaryViewParticleEffectEmojiId : null
                    })
                }) : memorizedReactions.map((reaction)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $3NvVh.Reaction), {
                        reaction: reaction,
                        emojiProvider: emojiProvider,
                        onClick: onReactionClick,
                        onMouseEnter: handleReactionMouseEnter,
                        onFocused: handleReactionFocused,
                        flash: flash[reaction.emojiId],
                        showParticleEffect: particleEffectByEmoji[reaction.emojiId],
                        showOpaqueBackground: showOpaqueBackground,
                        allowUserDialog: allowUserDialog && hasEmojiWithFivePlusReactions,
                        handleOpenReactionsDialog: handleOpenReactionsDialog,
                        isViewOnly: isViewOnly,
                        showSubtleStyle: showSubtleDefaultReactions && reactions.length === 0
                    }, reaction.emojiId))),
                isViewOnly || !onlyRenderPicker && shouldShowSummaryView && allowSelectFromSummaryView ? null : /*#__PURE__*/ (0, $7UHDa.jsx)($06ab72918ff66fb4$var$ReactionPicker, {
                    emojiProvider: emojiProvider,
                    allowAllEmojis: allowAllEmojis,
                    pickerQuickReactionEmojiIds: pickerQuickReactionEmojiIds,
                    disabled: status !== (0, $dyQ51.ReactionStatus).ready,
                    onSelection: handleOnSelection,
                    onOpen: handlePickerOpen,
                    onCancel: handleOnCancel,
                    onShowMore: handleOnMore,
                    tooltipContent: hoverableSummaryView ? null : $06ab72918ff66fb4$export$46455b4476d4b8e1(status, errorMessage, reactionPickerTriggerTooltipContent),
                    emojiPickerSize: emojiPickerSize,
                    miniMode: miniMode,
                    showOpaqueBackground: showOpaqueBackground,
                    showAddReactionText: showAddReactionText,
                    subtleReactionsSummaryAndPicker: subtleReactionsSummaryAndPicker,
                    reactionPickerTriggerIcon: reactionPickerTriggerIcon,
                    reactionPickerTriggerText: reactionPickerTriggerText,
                    isListItem: isListItem,
                    hoverableReactionPicker: hoverableSummaryView,
                    hoverableReactionPickerDelay: hoverableSummaryView ? 300 : 0,
                    reactionPickerPlacement: reactionPickerPlacement,
                    className: (0, $35pXk.default)([
                        "_1e0c1o8l _19pk1b66"
                    ])
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6xdDU.default), {
                    children: !!selectedEmojiId && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hnvzE.default), {
                        name: "reactions-dialog",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fER6k.ReactionsDialog), {
                            selectedEmojiId: selectedEmojiId,
                            reactions: sortedReactions,
                            emojiProvider: emojiProvider,
                            handleCloseReactionsDialog: handleCloseReactionsDialog,
                            handleSelectReaction: handleSelectReactionInDialog,
                            handlePaginationChange: handlePaginationChange,
                            ProfileCardWrapper: ProfileCardWrapper
                        })
                    })
                })
            ]
        })
    });
});

});
parcelRegister("jEwF8", function(module, exports) {

$parcel$export(module.exports, "isSampled", () => $42de0693b9004261$export$ed7a494f7df966be);
$parcel$export(module.exports, "createAndFireSafe", () => $42de0693b9004261$export$1b95a6072f2f9fae);
$parcel$export(module.exports, "createRestSucceededEvent", () => $42de0693b9004261$export$d61cc4fea6b821c6);
$parcel$export(module.exports, "createRestFailedEvent", () => $42de0693b9004261$export$33f46652cacb6853);
$parcel$export(module.exports, "createReactionsRenderedEvent", () => $42de0693b9004261$export$fd86d4b03f87495);
$parcel$export(module.exports, "createPickerButtonClickedEvent", () => $42de0693b9004261$export$5797d4afdfbf7ff2);
$parcel$export(module.exports, "createPickerCancelledEvent", () => $42de0693b9004261$export$aa268ce0cc416ab4);
$parcel$export(module.exports, "createPickerMoreClickedEvent", () => $42de0693b9004261$export$280ed8781309406f);
$parcel$export(module.exports, "createReactionSelectionEvent", () => $42de0693b9004261$export$6181167d075f0ec0);
$parcel$export(module.exports, "createReactionHoveredEvent", () => $42de0693b9004261$export$c7349958d247ace6);
$parcel$export(module.exports, "createReactionFocusedEvent", () => $42de0693b9004261$export$2402f68e3d87389c);
$parcel$export(module.exports, "createReactionClickedEvent", () => $42de0693b9004261$export$d3f48819b8df93ec);
$parcel$export(module.exports, "extractErrorInfo", () => $42de0693b9004261$export$74aaf4784c2edb2c);

var $eWRwJ = parcelRequire("eWRwJ");

var $7TH2w = parcelRequire("7TH2w");
const $42de0693b9004261$var$packageName = "platform-pkg";
const $42de0693b9004261$var$packageVersion = "0.0.0-use.local";
const $42de0693b9004261$export$ed7a494f7df966be = (rate)=>{
    if (rate === 1) return true;
    if (rate === 0) return false;
    return Math.random() * rate <= 1;
};
const $42de0693b9004261$export$53eef0dcd9611650 = (0, $eWRwJ.default)('fabric-elements');
const $42de0693b9004261$export$1b95a6072f2f9fae = (createAnalyticsEvent, creator, ...args)=>{
    if (createAnalyticsEvent) $42de0693b9004261$export$53eef0dcd9611650(creator(...args))(createAnalyticsEvent);
};
const $42de0693b9004261$var$createPayload = (action, actionSubject, eventType, actionSubjectId)=>(attributes = {})=>({
            action: action,
            actionSubject: actionSubject,
            eventType: eventType,
            actionSubjectId: actionSubjectId,
            attributes: {
                ...attributes,
                packageName: $42de0693b9004261$var$packageName,
                packageVersion: $42de0693b9004261$var$packageVersion
            }
        });
const $42de0693b9004261$var$calculateDuration = (startTime)=>startTime ? Date.now() - startTime : undefined;
const $42de0693b9004261$var$getPreviousState = (reaction)=>{
    if (reaction) {
        if (reaction.reacted) return 'existingReacted';
        return 'existingNotReacted';
    }
    return 'new';
};
const $42de0693b9004261$export$d61cc4fea6b821c6 = (actionSubject)=>$42de0693b9004261$var$createPayload('succeeded', actionSubject, (0, $7TH2w.OPERATIONAL_EVENT_TYPE))();
const $42de0693b9004261$export$33f46652cacb6853 = (actionSubject, errorCode)=>$42de0693b9004261$var$createPayload('failed', actionSubject, (0, $7TH2w.OPERATIONAL_EVENT_TYPE))({
        errorCode: errorCode
    });
const $42de0693b9004261$export$fd86d4b03f87495 = (startTime)=>$42de0693b9004261$var$createPayload('rendered', 'reactionView', (0, $7TH2w.OPERATIONAL_EVENT_TYPE))({
        duration: $42de0693b9004261$var$calculateDuration(startTime)
    });
const $42de0693b9004261$export$5797d4afdfbf7ff2 = (reactionEmojiCount)=>$42de0693b9004261$var$createPayload('clicked', 'reactionPickerButton', (0, $7TH2w.UI_EVENT_TYPE))({
        reactionEmojiCount: reactionEmojiCount
    });
const $42de0693b9004261$export$aa268ce0cc416ab4 = (startTime)=>$42de0693b9004261$var$createPayload('cancelled', 'reactionPicker', (0, $7TH2w.UI_EVENT_TYPE))({
        duration: $42de0693b9004261$var$calculateDuration(startTime)
    });
const $42de0693b9004261$export$280ed8781309406f = (startTime)=>$42de0693b9004261$var$createPayload('clicked', 'reactionPicker', (0, $7TH2w.UI_EVENT_TYPE), 'more')({
        duration: $42de0693b9004261$var$calculateDuration(startTime)
    });
const $42de0693b9004261$export$6181167d075f0ec0 = (source, emojiId, reaction, startTime)=>$42de0693b9004261$var$createPayload('clicked', 'reactionPicker', (0, $7TH2w.UI_EVENT_TYPE), 'emoji')({
        duration: $42de0693b9004261$var$calculateDuration(startTime),
        source: source,
        previousState: $42de0693b9004261$var$getPreviousState(reaction),
        emojiId: emojiId
    });
const $42de0693b9004261$export$c7349958d247ace6 = (startTime)=>$42de0693b9004261$var$createPayload('hovered', 'existingReaction', (0, $7TH2w.UI_EVENT_TYPE))({
        duration: $42de0693b9004261$var$calculateDuration(startTime)
    });
const $42de0693b9004261$export$2402f68e3d87389c = (startTime)=>$42de0693b9004261$var$createPayload('focused', 'existingReaction', (0, $7TH2w.UI_EVENT_TYPE))({
        duration: $42de0693b9004261$var$calculateDuration(startTime)
    });
const $42de0693b9004261$export$d3f48819b8df93ec = (added, emojiId)=>$42de0693b9004261$var$createPayload('clicked', 'existingReaction', (0, $7TH2w.UI_EVENT_TYPE))({
        added: added,
        emojiId: emojiId
    });
const $42de0693b9004261$export$74aaf4784c2edb2c = (error)=>{
    if (error instanceof Error) return {
        name: error.name,
        message: error.message
    };
    return error;
};

});

parcelRegister("dEmEP", function(module, exports) {

$parcel$export(module.exports, "DefaultReactions", () => $85da5b32bfc7b8df$export$a1b2ffe56d40782b);
$parcel$export(module.exports, "TOOLTIP_USERS_LIMIT", () => $85da5b32bfc7b8df$export$59a228d10bdb32fa);
$parcel$export(module.exports, "NUMBER_OF_REACTIONS_TO_DISPLAY", () => $85da5b32bfc7b8df$export$85d1598de110e7b3);
$parcel$export(module.exports, "SAMPLING_RATE_REACTIONS_RENDERED_EXP", () => $85da5b32bfc7b8df$export$50b3c15a723386a7);
$parcel$export(module.exports, "RESOURCED_EMOJI_COMPACT_HEIGHT", () => $85da5b32bfc7b8df$export$d78bee0d9fab78ad);
const $85da5b32bfc7b8df$export$a1b2ffe56d40782b = [
    {
        id: '1f44d',
        shortName: ':thumbsup:'
    },
    {
        id: '1f44f',
        shortName: ':clap:'
    },
    {
        id: '1f525',
        shortName: ':fire:'
    },
    {
        id: '2764',
        shortName: ':heart:'
    },
    {
        id: '1f632',
        shortName: ':astonished:'
    },
    {
        id: '1f914',
        shortName: ':thinking:'
    }
];
const $85da5b32bfc7b8df$export$86ad6a676949132c = [
    {
        id: '1f44d',
        shortName: ':thumbsup:'
    },
    {
        id: '1f44f',
        shortName: ':clap:'
    },
    {
        id: '1f525',
        shortName: ':fire:'
    },
    {
        id: '2764',
        shortName: ':heart:'
    },
    {
        id: '1f632',
        shortName: ':astonished:'
    },
    {
        id: '1f914',
        shortName: ':thinking:'
    },
    {
        id: '1f44e',
        shortName: ':thumbsdown:'
    },
    {
        id: '1f4a1',
        shortName: ':bulb:'
    },
    {
        id: '2b50',
        shortName: ':star:'
    },
    {
        id: '1f49a',
        shortName: ':green_heart:'
    },
    {
        id: '1f499',
        shortName: ':blue_heart:'
    },
    {
        id: '1f494',
        shortName: ':broken_heart:'
    },
    {
        id: '1f600',
        shortName: ':grinning:'
    },
    {
        id: '1f642',
        shortName: ':slight_smile:'
    }
];
const $85da5b32bfc7b8df$export$d8c2ebcd0ee41219 = new Map($85da5b32bfc7b8df$export$a1b2ffe56d40782b.map((reaction)=>[
        reaction.shortName,
        reaction
    ]));
const $85da5b32bfc7b8df$export$865044c189f353c2 = new Map($85da5b32bfc7b8df$export$86ad6a676949132c.map((reaction)=>[
        reaction.shortName,
        reaction
    ]));
const $85da5b32bfc7b8df$export$59a228d10bdb32fa = 5;
const $85da5b32bfc7b8df$export$85d1598de110e7b3 = 8;
const $85da5b32bfc7b8df$export$50b3c15a723386a7 = 50;
const $85da5b32bfc7b8df$export$d78bee0d9fab78ad = 16;

});

parcelRegister("9G3wK", function(module, exports) {

$parcel$export(module.exports, "messages", () => $aa555be3dee9eee4$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $aa555be3dee9eee4$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    addReaction: {
        id: "fabric.reactions.add",
        defaultMessage: "Add reaction"
    },
    addNewReaction: {
        id: "fabric.reactions.add.new",
        defaultMessage: "Add new"
    },
    loadingReactions: {
        id: "fabric.reactions.loading",
        defaultMessage: "Loading..."
    },
    moreEmoji: {
        id: "fabric.reactions.more.emojis",
        defaultMessage: "More emojis"
    },
    reactWithEmoji: {
        id: "fabric.reactions.reactwithemoji",
        defaultMessage: "React with {emoji} emoji"
    },
    reactWithEmojiAndCount: {
        id: "fabric.reactions.reactwithemojiandcount",
        defaultMessage: "{count, plural, one {# {emoji} emoji} other {# {emoji} emojis}}. React with {emoji} emoji"
    },
    summary: {
        id: "fabric.reactions.summary",
        defaultMessage: "View all user reactions"
    },
    unexpectedError: {
        id: "fabric.reactions.error.unexpected",
        defaultMessage: "Reactions are temporarily unavailable"
    },
    otherUsers: {
        id: "fabric.reactions.other.reacted.users",
        defaultMessage: "{count, plural, one {and one other} other {and {count} others}}"
    },
    closeReactionsDialog: {
        id: "reactions.dialog.close",
        defaultMessage: "Close"
    },
    reactionsCount: {
        id: "reactions.dialog.reactions.count",
        defaultMessage: "{count, plural, one {# total reaction} other {# total reactions} }"
    },
    leftNavigateLabel: {
        id: "reactions.dialog.left.navigate",
        defaultMessage: "Left Navigate"
    },
    rightNavigateLabel: {
        id: "reactions.dialog.right.navigate",
        defaultMessage: "Right Navigate"
    },
    emojiName: {
        id: "reactions.dialog.emoji.name",
        defaultMessage: "{emojiName}"
    },
    seeWhoReacted: {
        id: "reactions.dialog.viewall",
        defaultMessage: "View all"
    },
    seeWhoReactedTooltip: {
        id: "reactions.dialog.viewall.tooltip",
        defaultMessage: "View all user reactions"
    },
    popperWrapperLabel: {
        id: "reactions-reaction.picker-label",
        defaultMessage: "Add reactions"
    }
});

});

parcelRegister("dyQ51", function(module, exports) {

$parcel$export(module.exports, "ReactionUpdateType", () => $76ff71d161d3f76a$export$3618cac445fcd41d);
$parcel$export(module.exports, "ReactionStatus", () => $76ff71d161d3f76a$export$ae1bec9d610f93d3);
var $76ff71d161d3f76a$export$3618cac445fcd41d = /*#__PURE__*/ function(ReactionUpdateType) {
    ReactionUpdateType["added"] = "added";
    ReactionUpdateType["removed"] = "removed";
    return ReactionUpdateType;
}({});
var $76ff71d161d3f76a$export$ae1bec9d610f93d3 = /*#__PURE__*/ function(ReactionStatus) {
    ReactionStatus["ready"] = "READY";
    ReactionStatus["loading"] = "LOADING";
    ReactionStatus["error"] = "ERROR";
    ReactionStatus["notLoaded"] = "NOT_LOADED";
    ReactionStatus["disabled"] = "DISABLED";
    return ReactionStatus;
}({});

});

parcelRegister("1x5Ue", function(module, exports) {

$parcel$export(module.exports, "PickerRender", () => $42ba4d562e697306$export$6a3784263f4fa16e);
$parcel$export(module.exports, "ReactionsAdd", () => $42ba4d562e697306$export$2fe905192bb057);
$parcel$export(module.exports, "ReactionDialogOpened", () => $42ba4d562e697306$export$6d84aa1577071ff0);
$parcel$export(module.exports, "ReactionDialogSelectedReactionChanged", () => $42ba4d562e697306$export$ef9cf69898a6ff56);
$parcel$export(module.exports, "ReactionDetailsFetch", () => $42ba4d562e697306$export$517f7e3ffbcd0621);
$parcel$export(module.exports, "ReactionsRemove", () => $42ba4d562e697306$export$4f07dc8d2bdd140d);
$parcel$export(module.exports, "sampledReactionsRendered", () => $42ba4d562e697306$export$45a4d1bf25d8455d);

var $9801n = parcelRequire("9801n");
var $iqaft = parcelRequire("iqaft");
var $4SCyD = parcelRequire("4SCyD");

var $cGMbZ = parcelRequire("cGMbZ");
/**
 * Helper method for create the config type for an individual/Concurrent experience
 * @param componentName
 */ const $42ba4d562e697306$var$createExperienceConfig = (componentName, type, performanceType)=>{
    return {
        platform: {
            component: componentName
        },
        type: type,
        performanceType: performanceType
    };
};
var $42ba4d562e697306$export$b881bd9f00ed8ed1 = /*#__PURE__*/ function(ExperienceName) {
    ExperienceName["REACTIONS_RENDERED"] = "reactions-rendered";
    ExperienceName["PICKER_OPENED"] = "reactions-picker-opened";
    ExperienceName["REACTION_ADDED"] = "reaction-added";
    ExperienceName["REACTION_REMOVED"] = "reaction-removed";
    ExperienceName["REACTION_DETAILS_FETCHED"] = "reaction-details-fetched";
    ExperienceName["REACTION_DIALOG_OPENED"] = "reaction-dialog-opened";
    ExperienceName["REACTION_DIALOG_CLOSED"] = "reaction-dialog-closed";
    ExperienceName["REACTION_DIALOG_SELECTED_REACTION_CHANGED"] = "reaction-dialog-selected-reaction-changed";
    ExperienceName["REACTION_DIALOG_PAGE_NAVIGATION"] = "reaction-dialog-page-navigation";
    return ExperienceName;
}({});
var $42ba4d562e697306$export$57d347d1902b5fe6 = /*#__PURE__*/ function(ComponentName) {
    ComponentName["PICKER_RENDERED"] = "reactions-picker";
    ComponentName["REACTIONS"] = "reactions-list";
    ComponentName["REACTION_ITEM"] = "reaction-item";
    ComponentName["REACTION_DIALOG"] = "reaction-dialog";
    return ComponentName;
}({});
const $42ba4d562e697306$export$6a3784263f4fa16e = new (0, $4SCyD.UFOExperience)("reactions-picker-opened", $42ba4d562e697306$var$createExperienceConfig("reactions-picker", (0, $iqaft.ExperienceTypes).Experience, (0, $iqaft.ExperiencePerformanceTypes).InlineResult));
const $42ba4d562e697306$export$5990348071f4d2f = new (0, $9801n.ConcurrentExperience)("reactions-rendered", $42ba4d562e697306$var$createExperienceConfig("reactions-list", (0, $iqaft.ExperienceTypes).Load, (0, $iqaft.ExperiencePerformanceTypes).PageSegmentLoad));
const $42ba4d562e697306$export$2fe905192bb057 = new (0, $9801n.ConcurrentExperience)("reaction-added", $42ba4d562e697306$var$createExperienceConfig("reactions-list", (0, $iqaft.ExperienceTypes).Experience, (0, $iqaft.ExperiencePerformanceTypes).InlineResult));
const $42ba4d562e697306$export$6d84aa1577071ff0 = new (0, $4SCyD.UFOExperience)("reaction-dialog-opened", $42ba4d562e697306$var$createExperienceConfig("reaction-dialog", (0, $iqaft.ExperienceTypes).Experience, (0, $iqaft.ExperiencePerformanceTypes).InlineResult));
const $42ba4d562e697306$export$ef9cf69898a6ff56 = new (0, $4SCyD.UFOExperience)("reaction-dialog-selected-reaction-changed", $42ba4d562e697306$var$createExperienceConfig("reaction-dialog", (0, $iqaft.ExperienceTypes).Experience, (0, $iqaft.ExperiencePerformanceTypes).InlineResult));
const $42ba4d562e697306$export$517f7e3ffbcd0621 = new (0, $9801n.ConcurrentExperience)("reaction-details-fetched", $42ba4d562e697306$var$createExperienceConfig("reaction-item", (0, $iqaft.ExperienceTypes).Experience, (0, $iqaft.ExperiencePerformanceTypes).InlineResult));
const $42ba4d562e697306$export$4f07dc8d2bdd140d = new (0, $9801n.ConcurrentExperience)("reaction-removed", $42ba4d562e697306$var$createExperienceConfig("reactions-list", (0, $iqaft.ExperienceTypes).Experience, (0, $iqaft.ExperiencePerformanceTypes).InlineResult));
const $42ba4d562e697306$export$45a4d1bf25d8455d = (instanceId)=>(0, $cGMbZ.withSampling)($42ba4d562e697306$export$5990348071f4d2f.getInstance(instanceId));

});

parcelRegister("3NvVh", function(module, exports) {

$parcel$export(module.exports, "Reaction", () => $94de4b0ef07f5299$export$d2ae4167a30cf6bb);
/* Reaction.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dBxQj = parcelRequire("dBxQj");

var $inPa6 = parcelRequire("inPa6");

var $etuMO = parcelRequire("etuMO");

var $jEwF8 = parcelRequire("jEwF8");

var $lmASn = parcelRequire("lmASn");

var $boQXV = parcelRequire("boQXV");

var $8mOzm = parcelRequire("8mOzm");

var $9G3wK = parcelRequire("9G3wK");

var $bznvs = parcelRequire("bznvs");

var $dEmEP = parcelRequire("dEmEP");

var $gGaVB = parcelRequire("gGaVB");

var $lFe7k = parcelRequire("lFe7k");

var $gdv5Z = parcelRequire("gdv5Z");
var $u9agA = parcelRequire("u9agA");
const $94de4b0ef07f5299$var$styles = {
    container: "_kqswh2mm"
};
const $94de4b0ef07f5299$var$emojiStyle = null;
const $94de4b0ef07f5299$var$emojiNoReactionStyle = null; /**
                                    * Test id for Reaction item wrapper div
                                    */ 
const $94de4b0ef07f5299$export$b64f94cf5ea5f111 = 'render_reaction_wrapper';
const $94de4b0ef07f5299$export$d2ae4167a30cf6bb = ({ emojiProvider: emojiProvider, onClick: onClick, reaction: reaction, onMouseEnter: onMouseEnter = ()=>{}, onFocused: onFocused = ()=>{}, flash: flash = false, showParticleEffect: showParticleEffect = false, showOpaqueBackground: showOpaqueBackground = false, allowUserDialog: allowUserDialog, handleOpenReactionsDialog: handleOpenReactionsDialog, isViewOnly: isViewOnly = false, showSubtleStyle: showSubtleStyle })=>{
    const intl = (0, $dBxQj.default)();
    const hoverStart = (0, $gwFzn.useRef)();
    const focusStart = (0, $gwFzn.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [emojiName, setEmojiName] = (0, $gwFzn.useState)();
    const [isTooltipEnabled, setIsTooltipEnabled] = (0, $gwFzn.useState)(true);
    const { reacted: reacted } = reaction;
    const emojiId = {
        id: reaction.emojiId,
        shortName: ''
    }; // TODO: Extract the flow to a custom hook to retrieve emoji detailed description from an id using a custom hook. This will benefit a better optimization instead of the emojiProvider resolving everytime.
    // Also optimize in future version to fetch in batch several emojiIds
    (0, $gwFzn.useEffect)(()=>{
        (async ()=>{
            const emojiResource = await Promise.resolve(emojiProvider);
            const foundEmoji = await emojiResource.findById(reaction.emojiId);
            if (foundEmoji) setEmojiName(foundEmoji.name);
        })();
    }, [
        emojiProvider,
        reaction.emojiId
    ]);
    const handleClick = (0, $gwFzn.useCallback)((event)=>{
        event.preventDefault();
        if ((0, $bznvs.isLeftClick)(event)) {
            const { reacted: reacted, emojiId: emojiId } = reaction;
            (0, $jEwF8.createAndFireSafe)(createAnalyticsEvent, (0, $jEwF8.createReactionClickedEvent), !reacted, emojiId);
            onClick(reaction.emojiId, event);
        }
    }, [
        createAnalyticsEvent,
        reaction,
        onClick
    ]);
    const handleMouseEnter = (0, $gwFzn.useCallback)((event)=>{
        event.preventDefault();
        setIsTooltipEnabled(true);
        if (!reaction.users || !reaction.users.length) focusStart.current = Date.now();
        (0, $jEwF8.createAndFireSafe)(createAnalyticsEvent, (0, $jEwF8.createReactionHoveredEvent), focusStart.current);
        onMouseEnter(reaction.emojiId, event);
    }, [
        createAnalyticsEvent,
        reaction,
        onMouseEnter
    ]);
    const handleFocused = (0, $gwFzn.useCallback)((event)=>{
        event.preventDefault();
        setIsTooltipEnabled(true);
        if (!reaction.users || !reaction.users.length) hoverStart.current = Date.now();
        (0, $jEwF8.createAndFireSafe)(createAnalyticsEvent, (0, $jEwF8.createReactionFocusedEvent), hoverStart.current);
        onFocused(reaction.emojiId, event);
    }, [
        createAnalyticsEvent,
        reaction,
        onFocused
    ]);
    const dismissTooltip = ()=>{
        setIsTooltipEnabled(false);
    };
    const emojiAndCount = /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                className: (0, $35pXk.default)([
                    "_8hrz1nam _vwz41crf _ca0q1b66 _u5f31b66 _n3td1b66 _19bvu2gc",
                    reaction.count === 0 && "_ca0q1b66 _u5f3v77o _n3td1b66 _19bv19bv"
                ]),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $etuMO.default), {
                    emojiProvider: emojiProvider,
                    emojiId: emojiId,
                    fitToHeight: (0, $dEmEP.RESOURCED_EMOJI_COMPACT_HEIGHT)
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lmASn.Counter), {
                value: reaction.count,
                highlight: !isViewOnly && reaction.reacted
            })
        ]
    });
    let reactionAriaLabel = intl.formatMessage((0, $9G3wK.messages).reactWithEmoji, {
        emoji: emojiName
    });
    if (reaction.count) reactionAriaLabel = intl.formatMessage((0, $9G3wK.messages).reactWithEmojiAndCount, {
        emoji: emojiName,
        count: reaction.count
    });
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gdv5Z.default), {
        xcss: $94de4b0ef07f5299$var$styles.container,
        children: [
            showParticleEffect && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $boQXV.ReactionParticleEffect), {
                emojiId: emojiId,
                emojiProvider: emojiProvider
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8mOzm.ReactionTooltip), {
                emojiName: emojiName,
                reaction: reaction,
                isEnabled: isTooltipEnabled,
                allowUserDialog: allowUserDialog,
                handleOpenReactionsDialog: handleOpenReactionsDialog,
                dismissTooltip: dismissTooltip,
                children: isViewOnly ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lFe7k.StaticReaction), {
                    onMouseEnter: handleMouseEnter,
                    onFocus: handleFocused,
                    testId: $94de4b0ef07f5299$export$b64f94cf5ea5f111,
                    dataAttributes: {
                        'data-emoji-id': reaction.emojiId
                    },
                    children: emojiAndCount
                }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gGaVB.ReactionButton), {
                    onClick: handleClick,
                    flash: flash,
                    ariaLabel: reactionAriaLabel,
                    ariaPressed: reacted,
                    onMouseEnter: handleMouseEnter,
                    onFocus: handleFocused,
                    testId: $94de4b0ef07f5299$export$b64f94cf5ea5f111,
                    dataAttributes: {
                        'data-emoji-id': reaction.emojiId,
                        'data-emoji-button-id': reaction.emojiId
                    },
                    showOpaqueBackground: showOpaqueBackground,
                    showSubtleStyle: showSubtleStyle,
                    reacted: reacted,
                    children: emojiAndCount
                })
            })
        ]
    });
};

});
parcelRegister("lmASn", function(module, exports) {

$parcel$export(module.exports, "Counter", () => $3b41d7aabcc91d86$export$1b74141c5fe63a28);
/* Counter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $g9Srd = parcelRequire("g9Srd");
var $h3cbw = parcelRequire("h3cbw");

var $bznvs = parcelRequire("bznvs");
const $3b41d7aabcc91d86$var$containerStyle = null;
const $3b41d7aabcc91d86$var$counterLabelStyle = null;
const $3b41d7aabcc91d86$var$countStyle = null;
const $3b41d7aabcc91d86$var$highlightStyle = null;
const $3b41d7aabcc91d86$var$darkerFontStyle = null;
const $3b41d7aabcc91d86$var$updatedStyles = null; /**
                             * Test id for component top level div
                             */ 
const $3b41d7aabcc91d86$export$abd04e330cfe02b = 'counter-wrapper'; /**
                                                            * Test id for wrapper div of the counter inside the slider
                                                            */ 
const $3b41d7aabcc91d86$export$5d72ec7afc5923f4 = 'counter-container'; /**
                                                           * Counter label value wrapper div
                                                           */ 
const $3b41d7aabcc91d86$export$3b4c1ed5ad4af669 = 'counter_label_wrapper';
const $3b41d7aabcc91d86$export$1b74141c5fe63a28 = ({ highlight: highlight = false, limit: limit, overLimitLabel: overLimitLabel, className: className, value: value, animationDuration: animationDuration = 'medium', useDarkerFont: useDarkerFont, useUpdatedStyles: useUpdatedStyles })=>{
    const getLabel = (value)=>{
        // Check if reached limit
        if (limit && overLimitLabel && value >= limit) return overLimitLabel || '';
        else if (value === 0) return '';
        else return (0, $bznvs.formatLargeNumber)(value);
    };
    const lastValue = (0, $gwFzn.useRef)();
    const label = getLabel(value);
    (0, $gwFzn.useEffect)(()=>{
        lastValue.current = value;
    }, [
        value
    ]);
    const isIncreasing = (0, $gwFzn.useMemo)(()=>{
        return lastValue.current ? lastValue.current < value : false;
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $35pXk.default)([
            "_11c81o8v _1reo15vq _18m915vq _syaz131l _kqswh2mm _ca0q1b66 _u5f3u2gc _n3td1b66 _19bvidpf _vwz4dlk8",
            useDarkerFont && "_syaz1gjq",
            useUpdatedStyles && "_19pkv77o",
            className
        ]),
        "data-testid": $3b41d7aabcc91d86$export$abd04e330cfe02b,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $g9Srd.default), {
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $h3cbw.default), {
                enterFrom: isIncreasing ? 'top' : 'bottom',
                exitTo: isIncreasing ? 'top' : 'bottom',
                duration: animationDuration,
                children: (motion, direction)=>{
                    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                        ref: motion.ref,
                        style: {
                            position: direction === 'exiting' ? 'absolute' : undefined
                        },
                        className: (0, $35pXk.default)([
                            "_1e0c1txw _2lx21bp4",
                            motion.className
                        ]),
                        "data-testid": $3b41d7aabcc91d86$export$5d72ec7afc5923f4,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                            "data-testid": $3b41d7aabcc91d86$export$3b4c1ed5ad4af669,
                            className: (0, $35pXk.default)([
                                "_1x821ts4",
                                highlight && "_syazaqb7"
                            ]),
                            children: label
                        }, value)
                    });
                }
            }, value)
        })
    });
};

});
parcelRegister("bznvs", function(module, exports) {

$parcel$export(module.exports, "isLeftClick", () => $bc4a82f26fa22dc9$export$698c4f0ff5e11e52);
$parcel$export(module.exports, "formatLargeNumber", () => $bc4a82f26fa22dc9$export$2369f32a5da9d5b8);

var $dEmEP = parcelRequire("dEmEP");
const $bc4a82f26fa22dc9$export$698c4f0ff5e11e52 = (event)=>event.button === 0 && !event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey;
const $bc4a82f26fa22dc9$export$486a422686c27c1 = (item)=>(0, $dEmEP.DefaultReactions).some((otherEmojiId)=>$bc4a82f26fa22dc9$var$isEqualEmojiId(otherEmojiId, item));
/**
 * compare 2 emoji items if they are same input
 * @param a first emoji item
 * @param b second emoji item
 */ const $bc4a82f26fa22dc9$var$isEqualEmojiId = (a, b)=>{
    if ($bc4a82f26fa22dc9$var$isEmojiId(a) && $bc4a82f26fa22dc9$var$isEmojiId(b)) return a === b || a && b && a.id === b.id && a.shortName === b.shortName;
    else return a === b;
};
/**
 * Type guard if provided object is a string id or an object info collection for the emoji
 * @param item given item
 */ const $bc4a82f26fa22dc9$var$isEmojiId = (item)=>{
    return item.id !== undefined;
};
const $bc4a82f26fa22dc9$export$cabcad7683a98538 = (value, decimalPlaces)=>{
    const decimalIndex = value.indexOf('.');
    if (decimalIndex === -1) // Integers with trailing 0s will have no decimal (Ex. 18000, 7700000, 500)
    return value.substring(0, value.length);
    if (decimalPlaces === 0) // Return an integer value
    return value.substring(0, decimalIndex);
    return value.substring(0, decimalIndex + decimalPlaces + 1);
};
const $bc4a82f26fa22dc9$export$2369f32a5da9d5b8 = (value)=>{
    // 999M+
    const maxLimit = 999999999;
    const thounsandSeparator = 1000;
    const millionSeparator = 1000000;
    const valueInK = value / thounsandSeparator;
    const valueInM = value / millionSeparator;
    if (value > maxLimit) return '999.9M+';
    if (value >= 1000000) {
        // determine the decimal breakpoints by length and check its value
        // 1234567 -> 1.234567 and decimal value is 2
        const numDigits = value.toString().length;
        const decimalIndexValue = valueInM.toString().charAt(numDigits - 5);
        return decimalIndexValue === '0' ? $bc4a82f26fa22dc9$export$cabcad7683a98538(valueInM.toString(), 0) + 'M' : $bc4a82f26fa22dc9$export$cabcad7683a98538(valueInM.toString(), 1) + 'M';
    }
    if (value >= 1000) {
        const numDigits = value.toString().length;
        const decimalIndexValue = valueInK.toString().charAt(numDigits - 2);
        return decimalIndexValue === '0' ? $bc4a82f26fa22dc9$export$cabcad7683a98538(valueInK.toString(), 0) + 'K' : $bc4a82f26fa22dc9$export$cabcad7683a98538(valueInK.toString(), 1) + 'K';
    }
    // <999
    return value.toString();
};

});


parcelRegister("boQXV", function(module, exports) {

$parcel$export(module.exports, "ReactionParticleEffect", () => $96d55e55f83291a5$export$2538eeb2e8d3da5e);
/* ReactionParticleEffect.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $etuMO = parcelRequire("etuMO");

var $dEmEP = parcelRequire("dEmEP");
const $96d55e55f83291a5$var$containerStyle = null;
const $96d55e55f83291a5$var$reactionParticleStyle = null;
const $96d55e55f83291a5$export$ffc0241869fe445 = 4;
const $96d55e55f83291a5$export$2538eeb2e8d3da5e = ({ emojiProvider: emojiProvider, emojiId: emojiId })=>/*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        className: (0, $35pXk.default)([
            "_kqswh2mm _1ltvftgi _1pbyifev _m602idpf"
        ]),
        children: [
            ...Array($96d55e55f83291a5$export$ffc0241869fe445)
        ].map((_, index)=>{
            return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                className: (0, $35pXk.default)([
                    "_y44v7u0o _kqswstnw _154iidpf _1ltvidpf _lcxvglyw _tzy4idpf _5sagpwmj _1qen1lpd _xg4k6ebc _91vyftgi _1lac188d _jsy51n1a _7vm81dfm"
                ]),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $etuMO.default), {
                    emojiProvider: emojiProvider,
                    emojiId: emojiId,
                    fitToHeight: (0, $dEmEP.RESOURCED_EMOJI_COMPACT_HEIGHT)
                })
            }, index);
        })
    });

});

parcelRegister("8mOzm", function(module, exports) {

$parcel$export(module.exports, "ReactionTooltip", () => $1dd69b1ccdff8260$export$22b33b34188069b6);
/* ReactionTooltip.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $3gadb = parcelRequire("3gadb");

var $4jR19 = parcelRequire("4jR19");

var $dEmEP = parcelRequire("dEmEP");

var $9G3wK = parcelRequire("9G3wK");
const $1dd69b1ccdff8260$export$507197e0ca3872c2 = 5;
const $1dd69b1ccdff8260$var$tooltipStyle = null;
const $1dd69b1ccdff8260$var$emojiNameStyle = null;
const $1dd69b1ccdff8260$var$footerStyle = null;
const $1dd69b1ccdff8260$var$underlineStyle = null; /**
                              * Test id for wrapper ReactionTooltip div
                              */ 
const $1dd69b1ccdff8260$export$4850cb7690e62d5f = 'render-reactionTooltip';
const $1dd69b1ccdff8260$export$22b33b34188069b6 = ({ children: children, emojiName: emojiName, reaction: { users: users = [] }, maxReactions: maxReactions = (0, $dEmEP.TOOLTIP_USERS_LIMIT), isEnabled: isEnabled = true, allowUserDialog: allowUserDialog, handleOpenReactionsDialog: handleOpenReactionsDialog, dismissTooltip: dismissTooltip })=>{
    const handleClick = ()=>{
        if (allowUserDialog && handleOpenReactionsDialog) {
            dismissTooltip();
            handleOpenReactionsDialog();
        }
    };
    const content = !users || users.length === 0 || !isEnabled ? null : /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        tabIndex: 0,
        className: (0, $35pXk.default)([
            "_1reo15vq _18m915vq _p12f1w81 _1bto1l2s _o5721q9c _otyr14y2 _d1n8glyw _102oidpf _1kvxidpf _1ysjidpf _17d4idpf _1hziidpf _3n4midpf _ltofidpf _k7zyidpf _1ywo1e5h _1pru15vq _u0h115vq _5qec1l2s _1eg614y2"
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)("ul", {
            children: [
                emojiName ? /*#__PURE__*/ (0, $7UHDa.jsx)("li", {
                    className: (0, $35pXk.default)([
                        "_1p1d1dk0 _syaz15cr _k48p1pd9"
                    ]),
                    children: emojiName
                }) : null,
                users.slice(0, maxReactions).map((user)=>{
                    return /*#__PURE__*/ (0, $7UHDa.jsx)("li", {
                        children: user.displayName
                    }, user.id);
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("li", {
                    onMouseDown: handleClick,
                    onClick: handleClick,
                    className: (0, $35pXk.default)([
                        "_syaz15cr",
                        allowUserDialog && "_4bfu18uv _1hms8stv _ajmmnqa1 _80omtlke _irr3cdhy _30l315cr"
                    ]),
                    children: users.length > maxReactions && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                        ...(0, $9G3wK.messages).otherUsers,
                        values: {
                            count: users.length - maxReactions
                        }
                    })
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
        content: content,
        position: "bottom",
        testId: $1dd69b1ccdff8260$export$4850cb7690e62d5f,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.only(children)
    });
};

});

parcelRegister("gGaVB", function(module, exports) {

$parcel$export(module.exports, "ReactionButton", () => $6df7f276f34a0e36$export$6ce3894c36b53067);
/* ReactionButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $ddbVR = parcelRequire("ddbVR");

var $dpKIn = parcelRequire("dpKIn");

var $dh538 = parcelRequire("dh538");

var $fVUfS = parcelRequire("fVUfS");
const $6df7f276f34a0e36$var$styles = {
    reactionButton: "_2rko14q2 _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6dmuej _1e0c1txw _2lx2vrvc _4cvr1y6m _1ul914no _4t3i1tcg _bfhk1w7a _syaz1gjq _1pfh1b66 _12l21b66 _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _irr3166n _1di61dty",
    reactionStylesRefresh: "_2rkoglpi",
    reacted: "_1h6d1yqz _bfhkfg4m _irr3i1yw _1di619ru",
    opaqueBackground: "_bfhkvuon _irr3108i _1di61ji5",
    compactButton: "_4t3igktf _4cvr1h6o _19pk12x7",
    borderless: "_1dqoglyw"
};
/**
 * Default styling px height for an emoji reaction
 */ const $6df7f276f34a0e36$var$akHeight = 24;
const $6df7f276f34a0e36$var$flashHeight = $6df7f276f34a0e36$var$akHeight - 2; // height without the 1px border
const $6df7f276f34a0e36$var$flashStyle = null;
const $6df7f276f34a0e36$var$flashStyleOld = null;
const $6df7f276f34a0e36$export$6ce3894c36b53067 = ({ onClick: onClick, flash: flash = false, showSubtleStyle: showSubtleStyle, showOpaqueBackground: showOpaqueBackground, useCompactStyles: useCompactStyles, reacted: reacted, ariaLabel: ariaLabel, ariaPressed: ariaPressed, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onFocus: onFocus, children: children, dataAttributes: dataAttributes = {}, testId: testId })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fVUfS.default), {
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onFocus: onFocus,
        "aria-label": ariaLabel,
        "aria-pressed": ariaPressed,
        testId: testId,
        xcss: (0, $ddbVR.cx)($6df7f276f34a0e36$var$styles.reactionButton, useCompactStyles && $6df7f276f34a0e36$var$styles.compactButton, reacted && $6df7f276f34a0e36$var$styles.reacted, !reacted && showSubtleStyle && $6df7f276f34a0e36$var$styles.borderless, !reacted && showOpaqueBackground && $6df7f276f34a0e36$var$styles.opaqueBackground, // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        (0, $dh538.fg)('platform-component-visual-refresh') && $6df7f276f34a0e36$var$styles.reactionStylesRefresh),
        ...dataAttributes,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dpKIn.FlashAnimation), {
            flash: flash,
            className: (0, $35pXk.default)([
                (0, $dh538.fg)('platform-component-visual-refresh') ? "_2rkogqwt _1e0c1txw _2lx2vrvc _4cvr1h6o _4t3iqslr" : "_2rko19bv _1e0c1txw _2lx2vrvc _4cvr1h6o _4t3iqslr"
            ]),
            children: children
        })
    });
};

});
parcelRegister("dpKIn", function(module, exports) {

$parcel$export(module.exports, "FlashAnimation", () => $9d6ad9e0e36ddb79$export$2b501aee548bae06);
/* FlashAnimation.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $9d6ad9e0e36ddb79$var$flashTime = 700;
const $9d6ad9e0e36ddb79$var$flashAnimation = null;
const $9d6ad9e0e36ddb79$var$containerStyle = null;
const $9d6ad9e0e36ddb79$var$flashStyle = null;
const $9d6ad9e0e36ddb79$export$101a417749e701a3 = 'flash-animation'; /**
                                                                * Flash animation background component. See Reaction component for usage.
                                                                */ 
const $9d6ad9e0e36ddb79$export$2b501aee548bae06 = (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $35pXk.default)([
            "_1bsb1osq _4t3i1osq",
            props.flash && "",
            props.flash && "_j7hquey1 _5sagpwmj _1pgl1ytf",
            props.className
        ]),
        "data-testid": $9d6ad9e0e36ddb79$export$101a417749e701a3,
        children: props.children
    });

});


parcelRegister("lFe7k", function(module, exports) {

$parcel$export(module.exports, "StaticReaction", () => $a3b171ad8239dd96$export$1a66ed011c614568);
/* StaticReaction.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $fVUfS = parcelRequire("fVUfS");
const $a3b171ad8239dd96$var$styles = {
    staticReaction: "_1reo15vq _18m915vq _19itglyw _2rkoglpi _1e0c1txw _2lx2vrvc _4cvr1y6m _1ul914no _4t3i1tcg _bfhk1w7a _syaz1gjq _1pfh1b66 _12l21b66 _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _d0al73ad _irr3166n"
};
const $a3b171ad8239dd96$export$1a66ed011c614568 = ({ onMouseEnter: onMouseEnter, onFocus: onFocus, children: children, testId: testId, dataAttributes: dataAttributes = {} })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fVUfS.default), {
        onMouseEnter: onMouseEnter,
        onFocus: onFocus,
        testId: testId,
        xcss: $a3b171ad8239dd96$var$styles.staticReaction,
        ...dataAttributes,
        children: children
    });
};

});


parcelRegister("fER6k", function(module, exports) {

$parcel$export(module.exports, "ReactionsDialog", () => $e83fdec1e5228d21$export$df84a24235404de6);
/* ReactionsDialog.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $4A7Gn = parcelRequire("4A7Gn");

var $ekolh = parcelRequire("ekolh");
var $1DHa6 = parcelRequire("1DHa6");

var $gdv5Z = parcelRequire("gdv5Z");

var $dEmEP = parcelRequire("dEmEP");

var $86B4Q = parcelRequire("86B4Q");

var $lgOud = parcelRequire("lgOud");
const $e83fdec1e5228d21$var$styles = {
    modalBodyStyle: "_otyr1ejb"
}; /* Reactions Container. Using pseudo Element :after to set border since with onClick of Reaction to higlight the
   border blue below the reaction. */ 
const $e83fdec1e5228d21$var$containerStyle = null; /**
                              * Test id for the Reactions modal dialog
                              */ 
const $e83fdec1e5228d21$export$ef88759cddab4775 = 'render-reactions-modal';
const $e83fdec1e5228d21$export$df84a24235404de6 = ({ reactions: reactions = [], handleCloseReactionsDialog: handleCloseReactionsDialog = ()=>{}, emojiProvider: emojiProvider, selectedEmojiId: selectedEmojiId, handleSelectReaction: handleSelectReaction = ()=>{}, handlePaginationChange: handlePaginationChange = ()=>{}, ProfileCardWrapper: ProfileCardWrapper })=>{
    const [hasNavigatedPages, setHasNavigatedPages] = (0, $gwFzn.useState)(false);
    const [currentPage, setCurrentPage] = (0, $gwFzn.useState)(1);
    const totalReactionsCount = (0, $gwFzn.useMemo)(()=>{
        return reactions.reduce((accum, current)=>{
            return accum += current?.count;
        }, 0);
    }, [
        reactions
    ]);
    const maxPages = Math.max(1, Math.ceil(reactions.length / (0, $dEmEP.NUMBER_OF_REACTIONS_TO_DISPLAY)));
    const currentReactions = (0, $gwFzn.useMemo)(()=>{
        const start = (currentPage - 1) * (0, $dEmEP.NUMBER_OF_REACTIONS_TO_DISPLAY);
        const end = start + (0, $dEmEP.NUMBER_OF_REACTIONS_TO_DISPLAY);
        return reactions.slice(start, end);
    }, [
        reactions,
        currentPage
    ]);
    const handleNextPage = ()=>{
        setCurrentPage((prevPage)=>Math.min(prevPage + 1, maxPages));
        setHasNavigatedPages(true);
    };
    const handlePreviousPage = ()=>{
        setCurrentPage((prevPage)=>Math.max(prevPage - 1, 1));
        setHasNavigatedPages(true);
    };
    const firstEmojiOnPage = currentReactions[0]?.emojiId;
    (0, $gwFzn.useEffect)(()=>{
        // trigger the handler with the first emoji when the page changes
        if (hasNavigatedPages && firstEmojiOnPage) handlePaginationChange(firstEmojiOnPage, currentPage, maxPages);
    }, [
        hasNavigatedPages,
        currentPage,
        maxPages,
        firstEmojiOnPage,
        handlePaginationChange
    ]);
    const selectedIndex = currentReactions.findIndex((reaction)=>reaction.emojiId === selectedEmojiId);
    const onTabChange = (0, $gwFzn.useCallback)((index)=>{
        if (index === selectedIndex) return;
        const emojiId = currentReactions[index].emojiId;
        handleSelectReaction(emojiId);
    }, [
        selectedIndex,
        currentReactions,
        handleSelectReaction
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ekolh.default), {
        onClose: handleCloseReactionsDialog,
        height: 600,
        testId: $e83fdec1e5228d21$export$ef88759cddab4775,
        autoFocus: false,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $4A7Gn.default), {
            id: "reactions-dialog-tabs",
            onChange: onTabChange,
            selected: selectedIndex,
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lgOud.ReactionsDialogHeader), {
                    totalReactionsCount: totalReactionsCount,
                    maxPages: maxPages,
                    handlePreviousPage: handlePreviousPage,
                    handleNextPage: handleNextPage,
                    currentPage: currentPage,
                    emojiProvider: emojiProvider,
                    currentReactions: currentReactions,
                    handleCloseReactionsDialog: handleCloseReactionsDialog
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1DHa6.default), {
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                        xcss: $e83fdec1e5228d21$var$styles.modalBodyStyle,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                            className: (0, $35pXk.default)([
                                "_1reo15vq _18m915vq _4t3i1osq _1e0c1txw _1bahv2br _kqswh2mm _1dm8q5uf _aetrb3bt _1bqqidpf _1ywu1ule _1yd81osq _1x88idpf _18postnw"
                            ]),
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $86B4Q.ReactionsList), {
                                selectedEmojiId: selectedEmojiId,
                                reactions: currentReactions,
                                ProfileCardWrapper: ProfileCardWrapper
                            })
                        })
                    })
                })
            ]
        })
    });
};

});
parcelRegister("86B4Q", function(module, exports) {

$parcel$export(module.exports, "ReactionsList", () => $25ca5969823ca451$export$a87089fe362b9d93);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $gdv5Z = parcelRequire("gdv5Z");

var $cjv2f = parcelRequire("cjv2f");
const $25ca5969823ca451$export$a87089fe362b9d93 = ({ reactions: reactions, selectedEmojiId: selectedEmojiId, ProfileCardWrapper: ProfileCardWrapper })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        children: reactions.map((reaction)=>{
            if (reaction.emojiId === selectedEmojiId) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cjv2f.ReactionView), {
                reaction: reaction,
                ProfileCardWrapper: ProfileCardWrapper
            }, reaction.emojiId);
            else return null;
        })
    });
};

});
parcelRegister("cjv2f", function(module, exports) {

$parcel$export(module.exports, "ReactionView", () => $552ae0df23a1327d$export$5ad09c2943879b39);
/* ReactionView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $esRft = parcelRequire("esRft");

var $9hlns = parcelRequire("9hlns");

var $d2kvf = parcelRequire("d2kvf");

var $gdv5Z = parcelRequire("gdv5Z");
var $1s5hv = parcelRequire("1s5hv");
const $552ae0df23a1327d$var$userListStyle = null;
const $552ae0df23a1327d$var$userStyle = null;
const $552ae0df23a1327d$var$styles = {
    userDescriptionStyle: "_18u0utpp",
    profileWrapperStyle: "_18u0ze3t",
    reactionViewStyle: "_19pkutpp _1tke1mjv _1ul91deq",
    centerSpinnerStyle: "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3i1osq _19pk1ejb"
};
const $552ae0df23a1327d$export$5ad09c2943879b39 = ({ reaction: reaction, ProfileCardWrapper: ProfileCardWrapper })=>{
    const alphabeticalNames = (0, $gwFzn.useMemo)(()=>{
        const reactionObj = reaction;
        return reactionObj.users?.sort((a, b)=>a.displayName.localeCompare(b.displayName)) || [];
    }, [
        reaction
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $d2kvf.default), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1s5hv.default), {
            direction: "column",
            xcss: $552ae0df23a1327d$var$styles.reactionViewStyle,
            children: alphabeticalNames.length === 0 ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                xcss: $552ae0df23a1327d$var$styles.centerSpinnerStyle,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9hlns.default), {
                    size: "large",
                    interactionName: "reactions-spinner"
                })
            }) : /*#__PURE__*/ (0, $7UHDa.jsx)("ul", {
                className: (0, $35pXk.default)([
                    "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkpxbi _y3gn1e5h _nccu2smr _thoc1fxt"
                ]),
                children: alphabeticalNames.map((user)=>{
                    const profile = user.profilePicture?.path;
                    return /*#__PURE__*/ (0, $7UHDa.jsxs)("li", {
                        className: (0, $35pXk.default)([
                            "_1e0c1txw _4cvr1h6o _ca0q1b66 _n3td1b66 _19bvidpf _u5f3idpf _24rcpxbi"
                        ]),
                        children: [
                            ProfileCardWrapper && user.accountId ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                                xcss: $552ae0df23a1327d$var$styles.profileWrapperStyle,
                                children: /*#__PURE__*/ (0, $7UHDa.jsx)(ProfileCardWrapper, {
                                    userId: user.accountId,
                                    isAnonymous: false,
                                    canViewProfile: true,
                                    position: "left-start",
                                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $esRft.default), {
                                        size: "medium",
                                        src: profile,
                                        testId: "profile"
                                    })
                                })
                            }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $esRft.default), {
                                size: "medium",
                                src: profile,
                                testId: "profile"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1s5hv.default), {
                                xcss: $552ae0df23a1327d$var$styles.userDescriptionStyle,
                                children: /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                                    children: user.displayName
                                })
                            })
                        ]
                    }, user.id);
                })
            })
        })
    });
};

});


parcelRegister("lgOud", function(module, exports) {

$parcel$export(module.exports, "ReactionsDialogHeader", () => $43b2e7c985bcf61c$export$6c6a0fee39bccb13);
/* ReactionsDialogHeader.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dBxQj = parcelRequire("dBxQj");

var $cOrQJ = parcelRequire("cOrQJ");

var $8TTLA = parcelRequire("8TTLA");
var $804cB = parcelRequire("804cB");

var $gCbPZ = parcelRequire("gCbPZ");
var $0DTaW = parcelRequire("0DTaW");

var $gdv5Z = parcelRequire("gdv5Z");
var $1s5hv = parcelRequire("1s5hv");
var $u9agA = parcelRequire("u9agA");
var $eyWa4 = parcelRequire("eyWa4");

var $1qfLF = parcelRequire("1qfLF");

var $7hXDW = parcelRequire("7hXDW");

var $3gadb = parcelRequire("3gadb");

var $lL9CZ = parcelRequire("lL9CZ");

var $jPwBx = parcelRequire("jPwBx");

var $lnqHu = parcelRequire("lnqHu");

var $etuMO = parcelRequire("etuMO");

var $dh538 = parcelRequire("dh538");

var $9G3wK = parcelRequire("9G3wK");

var $lmASn = parcelRequire("lmASn");

var $dEmEP = parcelRequire("dEmEP");
const $43b2e7c985bcf61c$var$styles = {
    leftNavigationStyle: "_19pk1b66 _1wpzynz6 _19bvpxbi _n3tdutpp",
    rightNavigationStyle: "_19pk1b66 _1wpzynz6 _18u01wug _2hwxu2gc",
    fullWidthStyle: "_1bsb1osq _ca0q1ejb _19bv1ejb _u5f31ejb _85i5xy5q",
    emoji: "_1rjc1b66 _8hrz1nam _bozgu2gc _y4ti1b66",
    counterStyle: "_19pkv77o"
};
const $43b2e7c985bcf61c$var$REACTIONS_CONTAINER_WIDTH = 56;
const $43b2e7c985bcf61c$var$REACTION_CONTAINER_HEIGHT = 40;
const $43b2e7c985bcf61c$var$customTabListStyles = null;
const $43b2e7c985bcf61c$var$customTabWrapper = {
    base: "_1o9zidpf _1e0c1txw _2lx21bp4 _y3gn1h6o _4cvr1h6o _1bah1h6o _1ul98vuz _vchhusvi _kqswh2mm _ogwtgrf3 _6tingrf3 _1cezgrf3 _m3zkgrf3 _6kbe8vuz _1yfp1ylp _dzc21h6o _tij01h6o _nhkt1ecz _2t1tb3bt _mwnsstnw _axenidpf _1xogidpf _1gbg8vuz _rqy31ylp _1jzxidpf _j5n71tsn _c0nrb3bt _1wqistnw _5e04idpf _clnfidpf _1ks28vuz _1ira1ylp _8bggidpf _10d67vkz _aezr7vkz",
    darkTheme: "_nhktj96x _j5n7zopo"
};
const $43b2e7c985bcf61c$var$firstElement = null;
const $43b2e7c985bcf61c$var$CloseButtonCustom = ({ handleCloseReactionsDialog: handleCloseReactionsDialog })=>{
    const intl = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
        onClick: handleCloseReactionsDialog,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lnqHu))),
        label: intl.formatMessage((0, $9G3wK.messages).closeReactionsDialog),
        appearance: "subtle",
        isTooltipDisabled: false
    });
};
const $43b2e7c985bcf61c$var$LeftNavigationButton = ({ handlePreviousPage: handlePreviousPage })=>{
    const intl = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1s5hv.default), {
        xcss: $43b2e7c985bcf61c$var$styles.leftNavigationStyle,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
            spacing: "compact",
            onClick: handlePreviousPage,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lL9CZ))),
            label: intl.formatMessage((0, $9G3wK.messages).leftNavigateLabel),
            isTooltipDisabled: false
        })
    });
};
const $43b2e7c985bcf61c$var$RightNavigationButton = ({ handleNextPage: handleNextPage })=>{
    const intl = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1s5hv.default), {
        xcss: $43b2e7c985bcf61c$var$styles.rightNavigationStyle,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
            spacing: "compact",
            onClick: handleNextPage,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jPwBx))),
            label: intl.formatMessage((0, $9G3wK.messages).rightNavigateLabel),
            isTooltipDisabled: false
        })
    });
};
const $43b2e7c985bcf61c$export$6c6a0fee39bccb13 = ({ totalReactionsCount: totalReactionsCount, handlePreviousPage: handlePreviousPage, handleNextPage: handleNextPage, currentPage: currentPage, maxPages: maxPages, currentReactions: currentReactions, emojiProvider: emojiProvider, handleCloseReactionsDialog: handleCloseReactionsDialog })=>{
    const [cache, setCache] = (0, $gwFzn.useState)({});
    const { titleId: titleId } = (0, $804cB.useModal)();
    const intl = (0, $dBxQj.default)();
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const isSinglePage = maxPages === 1;
    const isOnFirstPage = currentPage === 1;
    const isOnLastPage = currentPage === maxPages;
    const handleMouseEnter = (reaction)=>{
        const { emojiId: emojiId } = reaction;
        if (!emojiId || cache[emojiId]) return;
        (async ()=>{
            // Note: not a network request e.g. ReactedUsersQuery
            const provider = await emojiProvider;
            const emoji = await provider.findByEmojiId({
                shortName: '',
                id: emojiId
            });
            if (emoji?.name) {
                // capitalize first letter of each string
                const capitalizedName = emoji.name.replace(/\b\w/g, (char)=>char.toUpperCase());
                setCache((prevCache)=>({
                        ...prevCache,
                        [emojiId]: capitalizedName
                    }));
            }
        })();
    };
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $eyWa4.default), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $1s5hv.default), {
                direction: "row",
                justifyContent: "space-between",
                alignItems: "center",
                xcss: $43b2e7c985bcf61c$var$styles.fullWidthStyle,
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7hXDW.default), {
                        size: "medium",
                        id: titleId,
                        children: intl.formatMessage((0, $9G3wK.messages).reactionsCount, {
                            count: totalReactionsCount
                        })
                    }),
                    (0, $dh538.fg)('platform-make-accessible-close-button') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8TTLA.CloseButton), {
                        onClick: handleCloseReactionsDialog
                    }) : /*#__PURE__*/ (0, $7UHDa.jsx)($43b2e7c985bcf61c$var$CloseButtonCustom, {
                        handleCloseReactionsDialog: handleCloseReactionsDialog
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $u9agA.default), {
                children: /*#__PURE__*/ (0, $7UHDa.jsxs)("div", {
                    id: "reactions-dialog-tabs-list",
                    className: (0, $35pXk.default)([
                        "_1reo1wug _18m91wug _n7zlzgxb _1e0c1txw _1bsb1osq _4cvr1y6m _80wau2gc _s2c4kb7n _141m18uv"
                    ]),
                    children: [
                        !isSinglePage && !isOnFirstPage && /*#__PURE__*/ (0, $7UHDa.jsx)($43b2e7c985bcf61c$var$LeftNavigationButton, {
                            handlePreviousPage: handlePreviousPage
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $0DTaW.default), {
                            children: [
                                currentReactions.map((reaction, index)=>{
                                    const emojiId = {
                                        id: reaction.emojiId,
                                        shortName: ''
                                    };
                                    return /*#__PURE__*/ (0, $7UHDa.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                    , {
                                        className: (0, $35pXk.default)([
                                            $43b2e7c985bcf61c$var$customTabWrapper.base,
                                            colorMode === 'dark' && $43b2e7c985bcf61c$var$customTabWrapper.darkTheme,
                                            index === 0 && "_19bvpxbi",
                                            "reaction-elements"
                                        ]),
                                        "data-testid": emojiId?.id,
                                        onMouseEnter: ()=>{
                                            handleMouseEnter(reaction);
                                        },
                                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gCbPZ.default), {
                                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
                                                content: cache[reaction.emojiId],
                                                canAppear: ()=>!!cache[reaction.emojiId],
                                                children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $1s5hv.default), {
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    direction: "row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                                                            xcss: $43b2e7c985bcf61c$var$styles.emoji,
                                                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $etuMO.default), {
                                                                emojiProvider: emojiProvider,
                                                                emojiId: emojiId,
                                                                fitToHeight: (0, $dEmEP.RESOURCED_EMOJI_COMPACT_HEIGHT),
                                                                showTooltip: true
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                                                            xcss: $43b2e7c985bcf61c$var$styles.counterStyle,
                                                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lmASn.Counter), {
                                                                value: reaction.count
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    }, reaction.emojiId);
                                }),
                                !isSinglePage && !isOnLastPage && /*#__PURE__*/ (0, $7UHDa.jsx)($43b2e7c985bcf61c$var$RightNavigationButton, {
                                    handleNextPage: handleNextPage
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

});


parcelRegister("8RXMv", function(module, exports) {

$parcel$export(module.exports, "ReactionPicker", () => $0913ef9ba03d719b$export$1d5ec51e9af399a5);
/* ReactionPicker.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $lGf1F = parcelRequire("lGf1F");

var $2ED7Q = parcelRequire("2ED7Q");
var $lqsSp = parcelRequire("lqsSp");
var $epI1O = parcelRequire("epI1O");

var $dTk3A = parcelRequire("dTk3A");

var $gdv5Z = parcelRequire("gdv5Z");

var $dh538 = parcelRequire("dh538");

var $2mb1r = parcelRequire("2mb1r");

var $6tNP7 = parcelRequire("6tNP7");

var $98jGc = parcelRequire("98jGc");

var $9G3wK = parcelRequire("9G3wK");

var $1x5Ue = parcelRequire("1x5Ue");

var $e11px = parcelRequire("e11px");

var $gIViu = parcelRequire("gIViu");

var $jRVtP = parcelRequire("jRVtP");
const $0913ef9ba03d719b$var$pickerStyle = null;
const $0913ef9ba03d719b$var$popupWrapperStyle = null;
const $0913ef9ba03d719b$var$popupStyle = null;
const $0913ef9ba03d719b$var$popupStyleWithMarginTop = null;
const $0913ef9ba03d719b$var$additionalStyles = {
    selectorContainer: "_1e0c1txw"
}; /**
    * Test id for wrapper ReactionPicker div
    */ 
const $0913ef9ba03d719b$export$4e9694165fb83edd = 'reactionPicker-testid'; /**
                                                                      * Test id for ReactionPicker panel div
                                                                      */ 
const $0913ef9ba03d719b$export$d52b610bc836b6d7 = 'reactionPickerPanel-testid'; /**
                                                                                * Emoji Picker Controller Id for Accessibility Labels
                                                                                */ 
const $0913ef9ba03d719b$var$PICKER_CONTROL_ID = 'emoji-picker';
const $0913ef9ba03d719b$export$1d5ec51e9af399a5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).memo((props)=>{
    const { miniMode: miniMode, className: className, emojiProvider: emojiProvider, onSelection: onSelection, allowAllEmojis: allowAllEmojis, disabled: disabled, pickerQuickReactionEmojiIds: pickerQuickReactionEmojiIds, onShowMore: onShowMore = ()=>{}, onOpen: onOpen = ()=>{}, onCancel: onCancel = ()=>{}, tooltipContent: tooltipContent = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
        ...(0, $9G3wK.messages).addReaction
    }), emojiPickerSize: emojiPickerSize, showOpaqueBackground: showOpaqueBackground = false, subtleReactionsSummaryAndPicker: subtleReactionsSummaryAndPicker = false, showAddReactionText: showAddReactionText = false, showRoundTrigger: showRoundTrigger = false, reactionPickerTriggerIcon: reactionPickerTriggerIcon, reactionPickerTriggerText: reactionPickerTriggerText, reactionPickerPlacement: reactionPickerPlacement, reactionsPickerPreventOverflowOptions: reactionsPickerPreventOverflowOptions, isListItem: isListItem = false, hoverableReactionPicker: hoverableReactionPicker = false, hoverableReactionPickerDelay: hoverableReactionPickerDelay = 0 } = props;
    const [triggerRef, setTriggerRef] = (0, $gwFzn.useState)(null);
    const [isHoverableReactionPickerEmojiPickerOpen, setIsHoverableReactionPickerEmojiPickerOpen] = (0, $gwFzn.useState)(false);
    const [isHoveringTrigger, setIsHoveringTrigger] = (0, $gwFzn.useState)(false);
    const [isHoveringPopup, setIsHoveringPopup] = (0, $gwFzn.useState)(false);
    const [isTriggerClicked, setIsTriggerClicked] = (0, $gwFzn.useState)(false);
    const [isPopupTrayOpen, setIsPopupTrayOpen] = (0, $6tNP7.useDelayedState)(false, hoverableReactionPickerDelay); /**
                                                                                                                * Container <div /> reference (used by custom hook to detect click outside)
                                                                                                                */ 
    const wrapperRef = (0, $gwFzn.useRef)(null);
    const updatePopper = (0, $gwFzn.useRef)();
    const popperPlacement = showRoundTrigger ? 'left' : reactionPickerPlacement || 'bottom-start';
    const popperModifiers = [
        /**
    Removing this applyStyle modifier as it throws client errors ref:
   https://popper.js.org/docs/v1/#modifiers
   https://popper.js.org/docs/v1/#modifiers..applyStyle
   { name: 'applyStyle', enabled: false },
    */ {
            name: 'hide',
            enabled: false
        },
        {
            name: 'offset',
            enabled: true,
            options: {
                offset: [
                    0,
                    (0, $dh538.fg)('platform-reactions-offset-based-popper') ? 4 : 0
                ]
            }
        },
        {
            name: 'flip',
            enabled: true,
            options: {
                flipVariations: true,
                boundariesElement: 'scrollParent'
            }
        },
        {
            name: 'preventOverflow',
            enabled: true,
            ...reactionsPickerPreventOverflowOptions && {
                options: reactionsPickerPreventOverflowOptions
            }
        }
    ];
    const [settings, setSettings] = (0, $gwFzn.useState)({
        /**
     * Show the full custom emoji list picker or the default list of emojis
     */ showFullPicker: !!allowAllEmojis && Array.isArray(pickerQuickReactionEmojiIds) && pickerQuickReactionEmojiIds.length === 0,
        popperPlacement: /**
     * Use left placement for popper - using value based on showRoundTrigger for now since it needs the left placement
     */ popperPlacement
    }); /**
       * Custom hook triggers when user clicks outside the reactions picker
       */ 
    (0, $2mb1r.useCloseManager)(wrapperRef, (callbackType)=>{
        close();
        onCancel();
        if (triggerRef && callbackType === 'ESCAPE') requestAnimationFrame(()=>triggerRef.focus());
    }, true, isPopupTrayOpen); /**
                              * Event callback when the picker is closed
                              * @param _id Optional id if an emoji button was selected or undefineed if was clicked outside the picker
                              */ 
    const close = (0, $gwFzn.useCallback)((_id)=>{
        setIsPopupTrayOpen(false, true); // ufo abort reaction experience
        (0, $1x5Ue.PickerRender).abort({
            metadata: {
                emojiId: _id,
                source: 'ReactionPicker',
                reason: 'close dialog'
            }
        });
        if (hoverableReactionPicker) {
            setIsHoverableReactionPickerEmojiPickerOpen(false);
            setIsTriggerClicked(false);
            setIsHoveringTrigger(false);
            setIsHoveringPopup(false);
        }
    }, [
        setIsPopupTrayOpen,
        setIsHoverableReactionPickerEmojiPickerOpen,
        hoverableReactionPicker,
        setIsTriggerClicked,
        setIsHoveringTrigger,
        setIsHoveringPopup
    ]); /**
                                                                                                                                                                  * Event handle rwhen selecting to show the custom emoji icons picker
                                                                                                                                                                  * @param e event param
                                                                                                                                                                  */ 
    const onSelectMoreClick = (0, $gwFzn.useCallback)((e)=>{
        e.preventDefault();
        setSettings({
            showFullPicker: hoverableReactionPicker ? settings.showFullPicker : true,
            popperPlacement: popperPlacement
        });
        setIsPopupTrayOpen(true);
        if (hoverableReactionPicker) {
            setIsHoverableReactionPickerEmojiPickerOpen(!isHoverableReactionPickerEmojiPickerOpen);
            setIsTriggerClicked(false);
        }
        onShowMore();
    }, [
        settings.showFullPicker,
        setIsPopupTrayOpen,
        onShowMore,
        popperPlacement,
        hoverableReactionPicker,
        setIsHoverableReactionPickerEmojiPickerOpen,
        isHoverableReactionPickerEmojiPickerOpen
    ]); /**
                                                                                                                                                                                                   * Event callback when an emoji icon is selected
                                                                                                                                                                                                   * @param item selected item
                                                                                                                                                                                                   */ 
    const onEmojiSelected = (0, $gwFzn.useCallback)((item)=>{
        // no emoji was selected
        if (!item.id) return;
        onSelection(item.id, settings.showFullPicker || hoverableReactionPicker && isHoverableReactionPickerEmojiPickerOpen ? 'emojiPicker' : 'quickSelector');
        close(item.id);
    }, [
        close,
        onSelection,
        settings.showFullPicker,
        hoverableReactionPicker,
        isHoverableReactionPickerEmojiPickerOpen
    ]); /**
                                                                                                                         * Event handler when the emoji icon to open the custom picker is selected
                                                                                                                         */ 
    const onTriggerClick = (0, $gwFzn.useCallback)(()=>{
        // ufo start reactions picker open experience
        (0, $1x5Ue.PickerRender).start();
        setSettings({
            ...settings,
            popperPlacement: popperPlacement
        });
        if (hoverableReactionPicker) {
            if (isHoverableReactionPickerEmojiPickerOpen || isTriggerClicked) {
                // if either the emoji picker is open or the trigger was clicked, close the popup and reset the state
                setIsTriggerClicked(false);
                setIsPopupTrayOpen(false, true);
            } else {
                // if neither condition is true, open the popup and set the state
                setIsTriggerClicked(true);
                setIsPopupTrayOpen(true, true);
            } // close the emoji picker
            setIsHoverableReactionPickerEmojiPickerOpen(false);
        } else setIsPopupTrayOpen(!isPopupTrayOpen);
        onOpen(); // ufo reactions picker opened success
        (0, $1x5Ue.PickerRender).success();
    }, [
        hoverableReactionPicker,
        isPopupTrayOpen,
        setIsPopupTrayOpen,
        isTriggerClicked,
        setIsTriggerClicked,
        isHoverableReactionPickerEmojiPickerOpen,
        onOpen,
        settings,
        popperPlacement
    ]);
    const handleTriggerMouseEnter = (0, $gwFzn.useCallback)(()=>{
        if (hoverableReactionPicker) {
            setIsHoveringTrigger(true);
            if (!isHoverableReactionPickerEmojiPickerOpen) setIsPopupTrayOpen(true);
        }
    }, [
        hoverableReactionPicker,
        isHoverableReactionPickerEmojiPickerOpen,
        setIsPopupTrayOpen
    ]);
    const handleTriggerMouseLeave = (0, $gwFzn.useCallback)(()=>{
        if (hoverableReactionPicker) {
            setIsHoveringTrigger(false);
            if (!isHoveringPopup && !isHoverableReactionPickerEmojiPickerOpen && !isTriggerClicked) setIsPopupTrayOpen(false);
        }
    }, [
        hoverableReactionPicker,
        isHoveringPopup,
        isHoverableReactionPickerEmojiPickerOpen,
        setIsPopupTrayOpen,
        isTriggerClicked
    ]);
    const handlePopupMouseEnter = (0, $gwFzn.useCallback)(()=>{
        if (hoverableReactionPicker) {
            setIsHoveringPopup(true);
            if (!isHoverableReactionPickerEmojiPickerOpen) setIsPopupTrayOpen(true);
        }
    }, [
        hoverableReactionPicker,
        isHoverableReactionPickerEmojiPickerOpen,
        setIsPopupTrayOpen
    ]);
    const handlePopupMouseLeave = (0, $gwFzn.useCallback)(()=>{
        if (hoverableReactionPicker) {
            setIsHoveringPopup(false);
            if (!isHoveringTrigger && !isHoverableReactionPickerEmojiPickerOpen && !isTriggerClicked) setIsPopupTrayOpen(false);
        }
    }, [
        hoverableReactionPicker,
        isHoveringTrigger,
        isHoverableReactionPickerEmojiPickerOpen,
        setIsPopupTrayOpen,
        isTriggerClicked
    ]);
    const wrapperClassName = ` ${isPopupTrayOpen ? 'isOpen' : ''} ${miniMode ? 'miniMode' : ''} ${className}`;
    (0, $gwFzn.useLayoutEffect)(()=>{
        updatePopper.current?.();
    }, [
        settings
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $35pXk.default)([
            "_s7n4nkob _1pra1o8l",
            wrapperClassName
        ]),
        "data-testid": $0913ef9ba03d719b$export$4e9694165fb83edd,
        ref: wrapperRef,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $2ED7Q.Manager), {
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $epI1O.Reference), {
                    children: ({ ref: ref })=>// Render a button to open the <Selector /> panel
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                            onMouseEnter: handleTriggerMouseEnter,
                            onMouseLeave: handleTriggerMouseLeave,
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gIViu.Trigger), {
                                ariaAttributes: {
                                    'aria-expanded': isPopupTrayOpen,
                                    'aria-controls': $0913ef9ba03d719b$var$PICKER_CONTROL_ID
                                },
                                ref: (node)=>{
                                    if (node && isPopupTrayOpen) {
                                        if (typeof ref === 'function') ref(node);
                                        else ref.current = node;
                                        setTriggerRef(node);
                                    }
                                },
                                isSelected: isPopupTrayOpen,
                                onClick: onTriggerClick,
                                miniMode: miniMode,
                                disabled: disabled,
                                tooltipContent: isPopupTrayOpen ? null : tooltipContent,
                                showOpaqueBackground: showOpaqueBackground,
                                showAddReactionText: showAddReactionText,
                                subtleReactionsSummaryAndPicker: subtleReactionsSummaryAndPicker,
                                showRoundTrigger: showRoundTrigger,
                                reactionPickerTriggerIcon: reactionPickerTriggerIcon,
                                reactionPickerTriggerText: reactionPickerTriggerText,
                                isListItem: isListItem
                            })
                        })
                }),
                isPopupTrayOpen && /*#__PURE__*/ (0, $7UHDa.jsx)($0913ef9ba03d719b$export$8c62d061746e97b3, {
                    settings: settings,
                    popperModifiers: popperModifiers,
                    children: settings.showFullPicker || hoverableReactionPicker && isHoverableReactionPickerEmojiPickerOpen ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lGf1F.default), {
                        emojiProvider: emojiProvider,
                        onSelection: onEmojiSelected,
                        size: emojiPickerSize
                    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                        xcss: $0913ef9ba03d719b$var$additionalStyles.selectorContainer,
                        onMouseEnter: handlePopupMouseEnter,
                        onMouseLeave: handlePopupMouseLeave,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $e11px.Selector), {
                            emojiProvider: emojiProvider,
                            onSelection: onEmojiSelected,
                            showMore: allowAllEmojis,
                            onMoreClick: onSelectMoreClick,
                            pickerQuickReactionEmojiIds: pickerQuickReactionEmojiIds,
                            hoverableReactionPickerSelector: hoverableReactionPicker
                        })
                    })
                })
            ]
        })
    });
});
const $0913ef9ba03d719b$export$8c62d061746e97b3 = (props)=>{
    const { settings: settings, children: children, popperModifiers: popperModifiers } = props;
    const [popupRef, setPopupRef] = (0, $gwFzn.useState)(null);
    const { formatMessage: formatMessage } = (0, $dBxQj.default)(); /**
                  * add focus lock to popup
                  */ 
    (0, $98jGc.useFocusTrap)({
        initialFocusRef: null,
        targetRef: popupRef
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lqsSp.Popper), {
        placement: settings.popperPlacement,
        modifiers: popperModifiers,
        strategy: "absolute",
        children: ({ ref: ref, style: style, update: update })=>{
            return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                role: "group",
                "aria-label": formatMessage((0, $9G3wK.messages).popperWrapperLabel),
                id: $0913ef9ba03d719b$var$PICKER_CONTROL_ID,
                "data-testid": $0913ef9ba03d719b$export$d52b610bc836b6d7,
                style: {
                    zIndex: (0, $dTk3A.layers).layer(),
                    ...style
                },
                ref: (node)=>{
                    if (node) {
                        if (typeof ref === 'function') ref(node);
                        else ref.current = node;
                        setPopupRef(node);
                    }
                },
                tabIndex: 0,
                className: (0, $35pXk.default)([
                    "_nt751r31 _49pcglyw _1hvw1o36"
                ]),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jRVtP.RepositionOnUpdate), {
                    update: update,
                    settings: settings,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                        className: (0, $35pXk.default)([
                            "_2rko1sit _bfhk1bhr _16qs1cd0 _79pa1b66",
                            !(0, $dh538.fg)('platform-reactions-offset-based-popper') && "_1bch1b66"
                        ]),
                        children: children
                    })
                })
            });
        }
    });
};

});
parcelRegister("2mb1r", function(module, exports) {

$parcel$export(module.exports, "useCloseManager", () => $7ebe1a33917443af$export$92dae2778ae88f9d);
$parcel$export(module.exports, "useCloseManagerV2", () => $7ebe1a33917443af$export$d6c3c92a8b7167c2);

var $gwFzn = parcelRequire("gwFzn");
function $7ebe1a33917443af$export$92dae2778ae88f9d(ref, callback, useCapture = false, enabled = true) {
    (0, $gwFzn.useEffect)(()=>{
        if (!enabled) return;
        /**
		 * Alert if clicked on outside of element
		 */ function handleClickOutside(event) {
            if (ref.current && event.target instanceof Node && !ref.current.contains(event.target)) callback('CLICK_OUTSIDE');
        }
        function handleKeydown(event) {
            const { key: key } = event;
            if (key === 'Escape' || key === 'Esc') callback('ESCAPE');
        }
        // Bind the event listener
        document.addEventListener('click', handleClickOutside, useCapture);
        document.addEventListener('keydown', handleKeydown);
        return ()=>{
            // Unbind the event listener on clean up
            document.removeEventListener('click', handleClickOutside, useCapture);
            document.removeEventListener('keydown', handleKeydown);
        };
    }, [
        ref,
        callback,
        useCapture,
        enabled
    ]);
}
function $7ebe1a33917443af$export$d6c3c92a8b7167c2(popupRef, triggerRef, callback, useCapture = false, enabled = true) {
    (0, $gwFzn.useEffect)(()=>{
        if (!enabled) return;
        /**
		 * Alert if clicked on outside of element
		 */ function handleClickOutside(event) {
            const target = event.target;
            const isClickOnPopup = popupRef && popupRef.contains(target);
            const isClickOnTrigger = triggerRef && triggerRef.contains(target);
            if (!isClickOnPopup && !isClickOnTrigger) callback('CLICK_OUTSIDE');
        }
        function handleKeydown(event) {
            const { key: key } = event;
            if (key === 'Escape' || key === 'Esc') callback('ESCAPE');
        }
        // Bind the event listener
        document.addEventListener('click', handleClickOutside, useCapture);
        document.addEventListener('keydown', handleKeydown);
        return ()=>{
            // Unbind the event listener on clean up
            document.removeEventListener('click', handleClickOutside, useCapture);
            document.removeEventListener('keydown', handleKeydown);
        };
    }, [
        triggerRef,
        popupRef,
        callback,
        useCapture,
        enabled
    ]);
}

});

parcelRegister("6tNP7", function(module, exports) {

$parcel$export(module.exports, "useDelayedState", () => $663439a7b3107909$export$94d25041dfc7e5be);

var $gwFzn = parcelRequire("gwFzn");
const $663439a7b3107909$export$94d25041dfc7e5be = (initialState, delay)=>{
    const [state, setState] = (0, $gwFzn.useState)(initialState);
    const timeoutRef = (0, $gwFzn.useRef)(null);
    (0, $gwFzn.useEffect)(()=>{
        return ()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, []);
    const handleDelayedStateChange = (0, $gwFzn.useCallback)((newState, immediate = false)=>{
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        if (immediate || delay === 0) setState(newState);
        else timeoutRef.current = setTimeout(()=>{
            setState(newState);
        }, delay);
    }, [
        delay
    ]);
    return [
        state,
        handleDelayedStateChange
    ];
};

});

parcelRegister("98jGc", function(module, exports) {

$parcel$export(module.exports, "useFocusTrap", () => $81f3d14465ba3022$export$5562a1f223a0d314);
/**
 * Custom hook to add focus trap
 * used for focus trap in ReactionPicker
 * copied from useFocusManager in @atlaskit/popup
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $7tiJw = parcelRequire("7tiJw");
const $81f3d14465ba3022$export$5562a1f223a0d314 = ({ targetRef: targetRef, initialFocusRef: initialFocusRef })=>{
    (0, $gwFzn.useEffect)(()=>{
        if (!targetRef) return;
        const trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: true,
            initialFocus: initialFocusRef || targetRef,
            fallbackFocus: targetRef,
            returnFocusOnDeactivate: false
        };
        const focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($7tiJw)))(targetRef, trapConfig);
        // wait for the popup to reposition itself before we focus
        let frameId = requestAnimationFrame(()=>{
            frameId = null;
            focusTrap.activate();
        });
        return ()=>{
            if (frameId != null) {
                cancelAnimationFrame(frameId);
                frameId = null;
            }
            focusTrap.deactivate();
        };
    }, [
        targetRef,
        initialFocusRef
    ]);
};

});

parcelRegister("e11px", function(module, exports) {

$parcel$export(module.exports, "Selector", () => $e03efae7ec46049d$export$d15f4cd5286f9b1e);
/* Selector.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $3gadb = parcelRequire("3gadb");

var $gdv5Z = parcelRequire("gdv5Z");
var $u9agA = parcelRequire("u9agA");

var $9G3wK = parcelRequire("9G3wK");

var $dEmEP = parcelRequire("dEmEP");

var $alo6p = parcelRequire("alo6p");

var $2A0lG = parcelRequire("2A0lG");

var $gIViu = parcelRequire("gIViu");
const $e03efae7ec46049d$var$styles = {
    container: "_ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
    separator: "_t6vde4h9 _5wramuej _1p3lnqa1 _ahbq1b66 _12l2u2gc _4t3i1tcg _1e0c1o8l",
    hoverableReactionPickerSelectorContainer: "_zulp1b66 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66"
};
const $e03efae7ec46049d$var$revealAnimation = null;
const $e03efae7ec46049d$var$revealStyle = null; /**
                           * Test id for wrapper Selector div
                           */ 
const $e03efae7ec46049d$export$fbfb01485b140555 = 'render-selector';
const $e03efae7ec46049d$var$Reveal = ({ children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        "data-testid": testId,
        className: (0, $35pXk.default)([
            "_j7hqordv _5sag6ebc _1pgl1ytf _1o51q7pw _tzy4idpf"
        ]),
        children: children
    });
}; /**
    * Reactions picker panel part of the <ReactionPicker /> component
    */ 
const $e03efae7ec46049d$export$d15f4cd5286f9b1e = ({ emojiProvider: emojiProvider, onMoreClick: onMoreClick, onSelection: onSelection, showMore: showMore, pickerQuickReactionEmojiIds: pickerQuickReactionEmojiIds = (0, $dEmEP.DefaultReactions), hoverableReactionPickerSelector: hoverableReactionPickerSelector = false })=>{
    /**
   * Render the default emoji icon
   * @param emoji emoji item
   * @param index location of the emoji in the array
   */ const renderEmoji = (emoji, index)=>{
        const emojiButtonAndTooltip = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
            content: emoji.shortName,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $alo6p.EmojiButton), {
                emojiId: emoji,
                emojiProvider: emojiProvider,
                onClick: onSelection,
                hoverableReactionPickerSelectorEmoji: hoverableReactionPickerSelector
            })
        });
        return hoverableReactionPickerSelector ? emojiButtonAndTooltip : /*#__PURE__*/ (0, $7UHDa.jsx)($e03efae7ec46049d$var$Reveal, {
            testId: $e03efae7ec46049d$export$fbfb01485b140555,
            children: emojiButtonAndTooltip
        }, emoji.id ?? emoji.shortName);
    };
    if (hoverableReactionPickerSelector) return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gdv5Z.default), {
        xcss: $e03efae7ec46049d$var$styles.hoverableReactionPickerSelectorContainer,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gIViu.Trigger), {
                tooltipContent: (0, $9G3wK.messages).addReaction.defaultMessage,
                onClick: onMoreClick,
                showAddReactionText: true,
                reactionPickerTriggerText: (0, $9G3wK.messages).addNewReaction.defaultMessage,
                fullWidthSelectorTrayReactionPickerTrigger: true
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $u9agA.default), {
                alignBlock: "center",
                xcss: hoverableReactionPickerSelector ? $e03efae7ec46049d$var$styles.hoverableReactionPickerSelectorContainer : $e03efae7ec46049d$var$styles.container,
                children: pickerQuickReactionEmojiIds ? pickerQuickReactionEmojiIds.map(renderEmoji) : null
            })
        ]
    });
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
        alignBlock: "center",
        xcss: $e03efae7ec46049d$var$styles.container,
        children: [
            pickerQuickReactionEmojiIds ? pickerQuickReactionEmojiIds.map(renderEmoji) : null,
            showMore ? /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gwFzn.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                        xcss: $e03efae7ec46049d$var$styles.separator
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)($e03efae7ec46049d$var$Reveal, {
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2A0lG.ShowMore), {
                            onClick: onMoreClick
                        }, "more")
                    })
                ]
            }) : null
        ]
    });
};

});
parcelRegister("alo6p", function(module, exports) {

$parcel$export(module.exports, "EmojiButton", () => $e01a5e78ffab5a4f$export$e6ce3311a4d41b7f);
/* EmojiButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $etuMO = parcelRequire("etuMO");

var $9G3wK = parcelRequire("9G3wK");

var $bznvs = parcelRequire("bznvs");

var $dEmEP = parcelRequire("dEmEP");

var $fVUfS = parcelRequire("fVUfS");
const $e01a5e78ffab5a4f$var$styles = {
    emojiButton: "_12ji1r31 _1qu2glyw _12y31o36 _2rkoglpi _189eidpf _1e0c1txw _bfhk1w7a _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _o7ksrkh3 _1llw1q5f",
    hoverableReactionPickerSelectorEmojiButton: "_12ji1r31 _1qu2glyw _12y31o36 _2rkoiti9 _189ee4h9 _1dqonqa1 _1h6dmuej _1e0c1txw _8hrz1nam _ca0qv77o _u5f31b66 _n3td1b66 _19bv1b66 _bfhk1w7a _syaz1gjq _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _irr3166n _1di61dty"
};
const $e01a5e78ffab5a4f$export$116e2ec39db7c58e = 'button-emoji-id';
const $e01a5e78ffab5a4f$export$e6ce3311a4d41b7f = ({ emojiId: emojiId, onClick: onClick, emojiProvider: emojiProvider, hoverableReactionPickerSelectorEmoji: hoverableReactionPickerSelectorEmoji })=>{
    const onButtonClick = (event)=>{
        event.preventDefault();
        if (onClick && (0, $bznvs.isLeftClick)(event)) onClick(emojiId, undefined, event);
    };
    const intl = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fVUfS.default), {
        testId: $e01a5e78ffab5a4f$export$116e2ec39db7c58e,
        onClick: onButtonClick,
        "aria-label": intl.formatMessage((0, $9G3wK.messages).reactWithEmoji, {
            emoji: emojiId.shortName
        }),
        xcss: hoverableReactionPickerSelectorEmoji ? $e01a5e78ffab5a4f$var$styles.hoverableReactionPickerSelectorEmojiButton : $e01a5e78ffab5a4f$var$styles.emojiButton,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $etuMO.default), {
            emojiProvider: emojiProvider,
            emojiId: emojiId,
            fitToHeight: hoverableReactionPickerSelectorEmoji ? (0, $dEmEP.RESOURCED_EMOJI_COMPACT_HEIGHT) : undefined
        })
    });
};

});

parcelRegister("2A0lG", function(module, exports) {

$parcel$export(module.exports, "ShowMore", () => $bfd483dd4e2fd3ed$export$ca7697601dcd7803);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $1qfLF = parcelRequire("1qfLF");

var $2wS8M = parcelRequire("2wS8M");

var $3gadb = parcelRequire("3gadb");

var $9G3wK = parcelRequire("9G3wK");
const $bfd483dd4e2fd3ed$export$3b6c19440cd8324b = 'show-more-button';
const $bfd483dd4e2fd3ed$export$ca7697601dcd7803 = ({ onClick: onClick })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
        ...(0, $9G3wK.messages).moreEmoji,
        children: (message)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
                content: message,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
                    label: (0, $9G3wK.messages).moreEmoji.defaultMessage,
                    onClick: onClick,
                    testId: $bfd483dd4e2fd3ed$export$3b6c19440cd8324b,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($2wS8M))),
                    appearance: "subtle"
                })
            })
    });
};

});

parcelRegister("gIViu", function(module, exports) {

$parcel$export(module.exports, "Trigger", () => $a4bdb11174aafd0a$export$41fb9f06171c75f4);
/* Trigger.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $3gadb = parcelRequire("3gadb");

var $gRg7d = parcelRequire("gRg7d");

var $dh538 = parcelRequire("dh538");

var $gdv5Z = parcelRequire("gdv5Z");
var $fVUfS = parcelRequire("fVUfS");

var $ddbVR = parcelRequire("ddbVR");

var $gwFzn = parcelRequire("gwFzn");
const $a4bdb11174aafd0a$var$styles = {
    trigger: "_2rko14q2 _189ee4h9 _1dqonqa1 _1ul9zwfg _4t3i1tcg _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _1e0c1txw _1bah1h6o _4cvr1h6o",
    subtleTrigger: "_1dqoglyw _1ul91tcg",
    expandedTrigger: "_1ul9146b",
    triggerStylesRefresh: "_2rkoglpi",
    roundTrigger: "_2rko14q2 _4t3iviql _1bsbviql",
    transparentEnabledTrigger: "_1h6dmuej _bfhk1w7a _irr3166n _1di61dty",
    opaqueEnabledTrigger: "_1h6dmuej _bfhkvuon _irr3108i _1di61ji5",
    disabledTrigger: "_1h6d13gt _bfhksyzs",
    miniMode: "_2rkoglpi _1dqoglyw _1ul91tcg _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
    fullWidthSummaryViewReactionPickerTrigger: "_1bsb1osq _ca0qu2gc _19bvu2gc _u5f3u2gc",
    fullWidthSelectorTrayReactionPickerTrigger: "_1bsb1osq _ca0q1b66 _19bv1b66 _u5f31b66",
    fullWidth: "_1bsb1osq _p12f3xl8"
};
const $a4bdb11174aafd0a$export$456835f64b911ea5 = 'render-tooltip-trigger';
const $a4bdb11174aafd0a$export$4397a1ddb3e8d706 = 'render-trigger-button';
const $a4bdb11174aafd0a$export$361f8ee5961b2075 = 'render-trigger-container';
const $a4bdb11174aafd0a$export$2243b1861b17bb3b = 'render-list-item-wrapper';
const $a4bdb11174aafd0a$var$i18n = (0, $2nPZH.defineMessages)({
    addReaction: {
        id: "reaction-picker-trigger.add.reaction.message",
        defaultMessage: "Add a reaction"
    }
});
const $a4bdb11174aafd0a$var$addReactionStyles = {
    addReactionMessage: "_11c8dcr7 _syaz1gjq _18u01b66"
};
const $a4bdb11174aafd0a$var$noMarkerListStyle = null; /**
                                 * Render an emoji button to open the reactions select picker
                                 */ 
const $a4bdb11174aafd0a$export$41fb9f06171c75f4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).forwardRef((props, ref)=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { onClick: onClick, miniMode: miniMode, tooltipContent: tooltipContent, disabled: disabled = false, ariaAttributes: ariaAttributes = {}, showOpaqueBackground: showOpaqueBackground = false, showAddReactionText: showAddReactionText = false, subtleReactionsSummaryAndPicker: subtleReactionsSummaryAndPicker = false, showRoundTrigger: showRoundTrigger = false, reactionPickerTriggerIcon: reactionPickerTriggerIcon, reactionPickerTriggerText: reactionPickerTriggerText = formatMessage($a4bdb11174aafd0a$var$i18n.addReaction), fullWidthSummaryViewReactionPickerTrigger: fullWidthSummaryViewReactionPickerTrigger = false, isListItem: isListItem = false, fullWidthSelectorTrayReactionPickerTrigger: fullWidthSelectorTrayReactionPickerTrigger = false } = props;
    const handleMouseDown = (e, analyticsEvent)=>{
        if (onClick && !disabled) onClick(e, analyticsEvent);
    };
    const renderPressableButton = ()=>/*#__PURE__*/ (0, $7UHDa.jsxs)((0, $fVUfS.default), {
            testId: $a4bdb11174aafd0a$export$4397a1ddb3e8d706,
            xcss: (0, $ddbVR.cx)($a4bdb11174aafd0a$var$styles.trigger, (fullWidthSummaryViewReactionPickerTrigger || fullWidthSelectorTrayReactionPickerTrigger) && $a4bdb11174aafd0a$var$styles.fullWidth, subtleReactionsSummaryAndPicker && $a4bdb11174aafd0a$var$styles.subtleTrigger, showAddReactionText && $a4bdb11174aafd0a$var$styles.expandedTrigger, disabled ? $a4bdb11174aafd0a$var$styles.disabledTrigger : showOpaqueBackground ? $a4bdb11174aafd0a$var$styles.opaqueEnabledTrigger : $a4bdb11174aafd0a$var$styles.transparentEnabledTrigger, miniMode && $a4bdb11174aafd0a$var$styles.miniMode, // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
            (0, $dh538.fg)('platform-component-visual-refresh') && $a4bdb11174aafd0a$var$styles.triggerStylesRefresh, showRoundTrigger && $a4bdb11174aafd0a$var$styles.roundTrigger),
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography
                lineHeight: '16px'
            },
            onClick: handleMouseDown,
            isDisabled: disabled,
            ref: ref,
            "data-subtle": subtleReactionsSummaryAndPicker,
            "data-mini-mode": miniMode,
            ...ariaAttributes,
            children: [
                !!reactionPickerTriggerIcon ? reactionPickerTriggerIcon : // TODO: https://product-fabric.atlassian.net/browse/DSP-21007
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gRg7d))), {
                    testId: "emoji-add-icon",
                    color: disabled ? "var(--ds-icon-disabled, #091E424F)" : "var(--ds-icon, #44546F)",
                    LEGACY_size: "small",
                    label: "Add reaction"
                }),
                showAddReactionText && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                    xcss: (0, $ddbVR.cx)($a4bdb11174aafd0a$var$addReactionStyles.addReactionMessage),
                    children: reactionPickerTriggerText
                })
            ]
        });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        xcss: (0, $ddbVR.cx)(fullWidthSummaryViewReactionPickerTrigger && $a4bdb11174aafd0a$var$styles.fullWidthSummaryViewReactionPickerTrigger, fullWidthSelectorTrayReactionPickerTrigger && $a4bdb11174aafd0a$var$styles.fullWidthSelectorTrayReactionPickerTrigger),
        testId: $a4bdb11174aafd0a$export$361f8ee5961b2075,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
            testId: $a4bdb11174aafd0a$export$456835f64b911ea5,
            content: tooltipContent,
            canAppear: ()=>!showAddReactionText,
            children: isListItem ? /*#__PURE__*/ (0, $7UHDa.jsx)("li", {
                "data-testid": $a4bdb11174aafd0a$export$2243b1861b17bb3b,
                className: (0, $35pXk.default)([
                    "_qtt8glyw"
                ]),
                children: renderPressableButton()
            }) : renderPressableButton()
        })
    });
});

});
parcelRegister("gRg7d", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::73bb0e29c7f7a728c3573234fe0b4d23>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c45e18c0fa2cbf05$var$_react = $c45e18c0fa2cbf05$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $c45e18c0fa2cbf05$var$_emojiAdd = $c45e18c0fa2cbf05$var$_interopRequireDefault((parcelRequire("4FHTF")));

var $c45e18c0fa2cbf05$var$_emojiAdd2 = $c45e18c0fa2cbf05$var$_interopRequireDefault((parcelRequire("3puEE")));
function $c45e18c0fa2cbf05$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EmojiAddIcon.
 * This component is EmojiAddIcon, with `UNSAFE_fallbackIcon` set to "EmojiAddIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding an emoji reaction.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c45e18c0fa2cbf05$var$EmojiAddIcon = (props)=>/*#__PURE__*/ $c45e18c0fa2cbf05$var$_react.default.createElement($c45e18c0fa2cbf05$var$_emojiAdd.default, Object.assign({
        LEGACY_fallbackIcon: $c45e18c0fa2cbf05$var$_emojiAdd2.default
    }, props));
$c45e18c0fa2cbf05$var$EmojiAddIcon.Name = 'EmojiAddIconMigration';
var $c45e18c0fa2cbf05$var$_default = module.exports.default = $c45e18c0fa2cbf05$var$EmojiAddIcon;

});



parcelRegister("jRVtP", function(module, exports) {

$parcel$export(module.exports, "RepositionOnUpdate", () => $a2ad7498d9460388$export$51eddd7655ca235a);
/**
 * Copied from ADS popup component with some tweeks for our use
 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
const $a2ad7498d9460388$export$51eddd7655ca235a = ({ children: children, update: update, settings: settings })=>{
    // Ref used here to skip update on first render (when refs haven't been set)
    const isFirstRenderRef = (0, $gwFzn.useRef)(true);
    (0, $gwFzn.useLayoutEffect)(()=>{
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update,
        settings
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Fragment), {
        children: children
    });
};

});


parcelRegister("4WjwD", function(module, exports) {

$parcel$export(module.exports, "ReactionPicker", () => $758e6dd35a9fd5e3$export$1d5ec51e9af399a5);
/* ReactionPickerNew.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $lGf1F = parcelRequire("lGf1F");

var $2ED7Q = parcelRequire("2ED7Q");
var $lqsSp = parcelRequire("lqsSp");
var $epI1O = parcelRequire("epI1O");

var $dTk3A = parcelRequire("dTk3A");

var $gdv5Z = parcelRequire("gdv5Z");

var $dh538 = parcelRequire("dh538");

var $2mb1r = parcelRequire("2mb1r");

var $6tNP7 = parcelRequire("6tNP7");

var $98jGc = parcelRequire("98jGc");

var $9G3wK = parcelRequire("9G3wK");

var $1x5Ue = parcelRequire("1x5Ue");

var $e11px = parcelRequire("e11px");

var $gIViu = parcelRequire("gIViu");

var $jRVtP = parcelRequire("jRVtP");

var $caX7N = parcelRequire("caX7N");
const $758e6dd35a9fd5e3$var$pickerStyle = null;
const $758e6dd35a9fd5e3$var$popupWrapperStyle = null;
const $758e6dd35a9fd5e3$var$popupStyle = null;
const $758e6dd35a9fd5e3$var$popupStyleWithMarginTop = null;
const $758e6dd35a9fd5e3$var$additionalStyles = {
    selectorContainer: "_1e0c1txw"
}; /**
    * Test id for wrapper ReactionPicker div
    */ 
const $758e6dd35a9fd5e3$export$4e9694165fb83edd = 'reactionPicker-testid'; /**
                                                                      * Test id for ReactionPicker panel div
                                                                      */ 
const $758e6dd35a9fd5e3$export$d52b610bc836b6d7 = 'reactionPickerPanel-testid'; /**
                                                                                * Emoji Picker Controller Id for Accessibility Labels
                                                                                */ 
const $758e6dd35a9fd5e3$var$PICKER_CONTROL_ID = 'emoji-picker';
const $758e6dd35a9fd5e3$export$1d5ec51e9af399a5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).memo((props)=>{
    const { miniMode: miniMode, className: className, emojiProvider: emojiProvider, onSelection: onSelection, allowAllEmojis: allowAllEmojis, disabled: disabled, pickerQuickReactionEmojiIds: pickerQuickReactionEmojiIds, onShowMore: onShowMore = ()=>{}, onOpen: onOpen = ()=>{}, onCancel: onCancel = ()=>{}, tooltipContent: tooltipContent = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
        ...(0, $9G3wK.messages).addReaction
    }), emojiPickerSize: emojiPickerSize, showOpaqueBackground: showOpaqueBackground = false, subtleReactionsSummaryAndPicker: subtleReactionsSummaryAndPicker = false, showAddReactionText: showAddReactionText = false, showRoundTrigger: showRoundTrigger = false, reactionPickerTriggerIcon: reactionPickerTriggerIcon, reactionPickerTriggerText: reactionPickerTriggerText, reactionPickerPlacement: reactionPickerPlacement, reactionsPickerPreventOverflowOptions: reactionsPickerPreventOverflowOptions, isListItem: isListItem = false, hoverableReactionPicker: hoverableReactionPicker = false, hoverableReactionPickerDelay: hoverableReactionPickerDelay = 0 } = props;
    const [triggerRef, setTriggerRef] = (0, $gwFzn.useState)(null);
    const [isHoverableReactionPickerEmojiPickerOpen, setIsHoverableReactionPickerEmojiPickerOpen] = (0, $gwFzn.useState)(false);
    const [isHoveringTrigger, setIsHoveringTrigger] = (0, $gwFzn.useState)(false);
    const [isHoveringPopup, setIsHoveringPopup] = (0, $gwFzn.useState)(false);
    const [isTriggerClicked, setIsTriggerClicked] = (0, $gwFzn.useState)(false);
    const [isPopupTrayOpen, setIsPopupTrayOpen] = (0, $6tNP7.useDelayedState)(false, hoverableReactionPickerDelay); /**
                                                                                                                * Container <div /> reference (used by custom hook to detect click outside)
                                                                                                                */ 
    const wrapperRef = (0, $gwFzn.useRef)(null);
    const updatePopper = (0, $gwFzn.useRef)();
    const popperPlacement = showRoundTrigger ? 'left' : reactionPickerPlacement || 'bottom-start';
    const popperModifiers = [
        /**
    Removing this applyStyle modifier as it throws client errors ref:
   https://popper.js.org/docs/v1/#modifiers
   https://popper.js.org/docs/v1/#modifiers..applyStyle
   { name: 'applyStyle', enabled: false },
    */ {
            name: 'hide',
            enabled: false
        },
        {
            name: 'offset',
            enabled: true,
            options: {
                offset: [
                    0,
                    (0, $dh538.fg)('platform-reactions-offset-based-popper') ? 4 : 0
                ]
            }
        },
        {
            name: 'flip',
            enabled: true,
            options: {
                flipVariations: true,
                boundariesElement: 'scrollParent'
            }
        },
        {
            name: 'preventOverflow',
            enabled: true,
            ...reactionsPickerPreventOverflowOptions && {
                options: reactionsPickerPreventOverflowOptions
            }
        }
    ];
    const [settings, setSettings] = (0, $gwFzn.useState)({
        /**
     * Show the full custom emoji list picker or the default list of emojis
     */ showFullPicker: !!allowAllEmojis && Array.isArray(pickerQuickReactionEmojiIds) && pickerQuickReactionEmojiIds.length === 0,
        popperPlacement: /**
     * Use left placement for popper - using value based on showRoundTrigger for now since it needs the left placement
     */ popperPlacement
    }); /**
       * Event callback when the picker is closed
       * @param _id Optional id if an emoji button was selected or undefineed if was clicked outside the picker
       */ 
    const close = (0, $gwFzn.useCallback)((_id)=>{
        setIsPopupTrayOpen(false, true); // ufo abort reaction experience
        (0, $1x5Ue.PickerRender).abort({
            metadata: {
                emojiId: _id,
                source: 'ReactionPicker',
                reason: 'close dialog'
            }
        });
        if (hoverableReactionPicker) {
            setIsHoverableReactionPickerEmojiPickerOpen(false);
            setIsTriggerClicked(false);
            setIsHoveringTrigger(false);
            setIsHoveringPopup(false);
        }
    }, [
        setIsPopupTrayOpen,
        setIsHoverableReactionPickerEmojiPickerOpen,
        hoverableReactionPicker,
        setIsTriggerClicked,
        setIsHoveringTrigger,
        setIsHoveringPopup
    ]); /**
                                                                                                                                                                  * Event handle rwhen selecting to show the custom emoji icons picker
                                                                                                                                                                  * @param e event param
                                                                                                                                                                  */ 
    const onSelectMoreClick = (0, $gwFzn.useCallback)((e)=>{
        e.preventDefault();
        setSettings({
            showFullPicker: hoverableReactionPicker ? settings.showFullPicker : true,
            popperPlacement: popperPlacement
        });
        setIsPopupTrayOpen(true);
        if (hoverableReactionPicker) {
            setIsHoverableReactionPickerEmojiPickerOpen(!isHoverableReactionPickerEmojiPickerOpen);
            setIsTriggerClicked(false);
        }
        onShowMore();
    }, [
        settings.showFullPicker,
        setIsPopupTrayOpen,
        onShowMore,
        popperPlacement,
        hoverableReactionPicker,
        setIsHoverableReactionPickerEmojiPickerOpen,
        isHoverableReactionPickerEmojiPickerOpen
    ]); /**
                                                                                                                                                                                                   * Event callback when an emoji icon is selected
                                                                                                                                                                                                   * @param item selected item
                                                                                                                                                                                                   */ 
    const onEmojiSelected = (0, $gwFzn.useCallback)((item)=>{
        // no emoji was selected
        if (!item.id) return;
        onSelection(item.id, settings.showFullPicker || hoverableReactionPicker && isHoverableReactionPickerEmojiPickerOpen ? 'emojiPicker' : 'quickSelector');
        close(item.id);
    }, [
        close,
        onSelection,
        settings.showFullPicker,
        hoverableReactionPicker,
        isHoverableReactionPickerEmojiPickerOpen
    ]); /**
                                                                                                                         * Event handler when the emoji icon to open the custom picker is selected
                                                                                                                         */ 
    const onTriggerClick = (0, $gwFzn.useCallback)(()=>{
        // ufo start reactions picker open experience
        (0, $1x5Ue.PickerRender).start();
        setSettings({
            ...settings,
            popperPlacement: popperPlacement
        });
        if (hoverableReactionPicker) {
            if (isHoverableReactionPickerEmojiPickerOpen || isTriggerClicked) {
                // if either the emoji picker is open or the trigger was clicked, close the popup and reset the state
                setIsTriggerClicked(false);
                setIsPopupTrayOpen(false, true);
            } else {
                // if neither condition is true, open the popup and set the state
                setIsTriggerClicked(true);
                setIsPopupTrayOpen(true, true);
            } // close the emoji picker
            setIsHoverableReactionPickerEmojiPickerOpen(false);
        } else setIsPopupTrayOpen(!isPopupTrayOpen);
        onOpen(); // ufo reactions picker opened success
        (0, $1x5Ue.PickerRender).success();
    }, [
        hoverableReactionPicker,
        isPopupTrayOpen,
        setIsPopupTrayOpen,
        isTriggerClicked,
        setIsTriggerClicked,
        isHoverableReactionPickerEmojiPickerOpen,
        onOpen,
        settings,
        popperPlacement
    ]);
    const handleTriggerMouseEnter = (0, $gwFzn.useCallback)(()=>{
        if (hoverableReactionPicker) {
            setIsHoveringTrigger(true);
            if (!isHoverableReactionPickerEmojiPickerOpen) setIsPopupTrayOpen(true);
        }
    }, [
        hoverableReactionPicker,
        isHoverableReactionPickerEmojiPickerOpen,
        setIsPopupTrayOpen
    ]);
    const handleTriggerMouseLeave = (0, $gwFzn.useCallback)(()=>{
        if (hoverableReactionPicker) {
            setIsHoveringTrigger(false);
            if (!isHoveringPopup && !isHoverableReactionPickerEmojiPickerOpen && !isTriggerClicked) setIsPopupTrayOpen(false);
        }
    }, [
        hoverableReactionPicker,
        isHoveringPopup,
        isHoverableReactionPickerEmojiPickerOpen,
        setIsPopupTrayOpen,
        isTriggerClicked
    ]);
    const handlePopupMouseEnter = (0, $gwFzn.useCallback)(()=>{
        if (hoverableReactionPicker) {
            setIsHoveringPopup(true);
            if (!isHoverableReactionPickerEmojiPickerOpen) setIsPopupTrayOpen(true);
        }
    }, [
        hoverableReactionPicker,
        isHoverableReactionPickerEmojiPickerOpen,
        setIsPopupTrayOpen
    ]);
    const handlePopupMouseLeave = (0, $gwFzn.useCallback)(()=>{
        if (hoverableReactionPicker) {
            setIsHoveringPopup(false);
            if (!isHoveringTrigger && !isHoverableReactionPickerEmojiPickerOpen && !isTriggerClicked) setIsPopupTrayOpen(false);
        }
    }, [
        hoverableReactionPicker,
        isHoveringTrigger,
        isHoverableReactionPickerEmojiPickerOpen,
        setIsPopupTrayOpen,
        isTriggerClicked
    ]);
    const wrapperClassName = ` ${isPopupTrayOpen ? 'isOpen' : ''} ${miniMode ? 'miniMode' : ''} ${className}`;
    (0, $gwFzn.useLayoutEffect)(()=>{
        updatePopper.current?.();
    }, [
        settings
    ]);
    const onClose = ()=>{
        close();
        onCancel();
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $35pXk.default)([
            "_s7n4nkob _1pra1o8l",
            wrapperClassName
        ]),
        "data-testid": $758e6dd35a9fd5e3$export$4e9694165fb83edd,
        ref: wrapperRef,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $2ED7Q.Manager), {
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $epI1O.Reference), {
                    children: ({ ref: ref })=>// Render a button to open the <Selector /> panel
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                            onMouseEnter: handleTriggerMouseEnter,
                            onMouseLeave: handleTriggerMouseLeave,
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gIViu.Trigger), {
                                ariaAttributes: {
                                    'aria-expanded': isPopupTrayOpen,
                                    'aria-controls': $758e6dd35a9fd5e3$var$PICKER_CONTROL_ID
                                },
                                ref: (node)=>{
                                    if (node && isPopupTrayOpen) {
                                        if (typeof ref === 'function') ref(node);
                                        else ref.current = node;
                                        setTriggerRef(node);
                                    }
                                },
                                isSelected: isPopupTrayOpen,
                                onClick: onTriggerClick,
                                miniMode: miniMode,
                                disabled: disabled,
                                tooltipContent: isPopupTrayOpen ? null : tooltipContent,
                                showOpaqueBackground: showOpaqueBackground,
                                showAddReactionText: showAddReactionText,
                                subtleReactionsSummaryAndPicker: subtleReactionsSummaryAndPicker,
                                showRoundTrigger: showRoundTrigger,
                                reactionPickerTriggerIcon: reactionPickerTriggerIcon,
                                reactionPickerTriggerText: reactionPickerTriggerText,
                                isListItem: isListItem
                            })
                        })
                }),
                isPopupTrayOpen && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $caX7N.default), {
                    zIndex: (0, $dTk3A.layers).layer(),
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)($758e6dd35a9fd5e3$export$8c62d061746e97b3, {
                        settings: settings,
                        popperModifiers: popperModifiers,
                        isOpen: isPopupTrayOpen,
                        onClose: onClose,
                        triggerRef: triggerRef,
                        children: settings.showFullPicker || hoverableReactionPicker && isHoverableReactionPickerEmojiPickerOpen ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lGf1F.default), {
                            emojiProvider: emojiProvider,
                            onSelection: onEmojiSelected,
                            size: emojiPickerSize
                        }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                            xcss: $758e6dd35a9fd5e3$var$additionalStyles.selectorContainer,
                            onMouseEnter: handlePopupMouseEnter,
                            onMouseLeave: handlePopupMouseLeave,
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $e11px.Selector), {
                                emojiProvider: emojiProvider,
                                onSelection: onEmojiSelected,
                                showMore: allowAllEmojis,
                                onMoreClick: onSelectMoreClick,
                                pickerQuickReactionEmojiIds: pickerQuickReactionEmojiIds,
                                hoverableReactionPickerSelector: hoverableReactionPicker
                            })
                        })
                    })
                })
            ]
        })
    });
});
const $758e6dd35a9fd5e3$export$8c62d061746e97b3 = (props)=>{
    const { triggerRef: triggerRef, settings: settings, isOpen: isOpen, onClose: onClose, children: children, popperModifiers: popperModifiers } = props;
    const [popupRef, setPopupRef] = (0, $gwFzn.useState)(null);
    const { formatMessage: formatMessage } = (0, $dBxQj.default)(); /**
                  * add focus lock to popup
                  */ 
    (0, $98jGc.useFocusTrap)({
        initialFocusRef: null,
        targetRef: popupRef
    }); /**
       * Custom hook triggers when user clicks outside the reactions picker
       */ 
    (0, $2mb1r.useCloseManagerV2)(popupRef, triggerRef, (callbackType)=>{
        onClose();
        if (popupRef && callbackType === 'ESCAPE') requestAnimationFrame(()=>triggerRef?.focus());
    }, true, isOpen);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lqsSp.Popper), {
        placement: settings.popperPlacement,
        modifiers: popperModifiers,
        children: ({ ref: ref, style: style, update: update })=>{
            return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                role: "group",
                "aria-label": formatMessage((0, $9G3wK.messages).popperWrapperLabel),
                id: $758e6dd35a9fd5e3$var$PICKER_CONTROL_ID,
                "data-testid": $758e6dd35a9fd5e3$export$d52b610bc836b6d7,
                style: {
                    zIndex: (0, $dTk3A.layers).layer(),
                    ...style
                },
                ref: (node)=>{
                    if (node) {
                        if (typeof ref === 'function') ref(node);
                        else ref.current = node;
                        setPopupRef(node);
                    }
                },
                tabIndex: 0,
                className: (0, $35pXk.default)([
                    "_nt751r31 _49pcglyw _1hvw1o36"
                ]),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jRVtP.RepositionOnUpdate), {
                    update: update,
                    settings: settings,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                        className: (0, $35pXk.default)([
                            "_2rko1sit _bfhk1bhr _16qs1cd0 _79pa1b66",
                            !(0, $dh538.fg)('platform-reactions-offset-based-popper') && "_1bch1b66"
                        ]),
                        children: children
                    })
                })
            });
        }
    });
};

});

parcelRegister("95fI5", function(module, exports) {

$parcel$export(module.exports, "ReactionSummaryView", () => $0a863c75712dbd4f$export$d441f1c2eaaec099);
/* ReactionSummaryView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $lGgRw = parcelRequire("lGgRw");

var $lGf1F = parcelRequire("lGf1F");

var $6tNP7 = parcelRequire("6tNP7");

var $3NvVh = parcelRequire("3NvVh");

var $gIViu = parcelRequire("gIViu");

var $g5P9l = parcelRequire("g5P9l");

var $1x5Ue = parcelRequire("1x5Ue");

var $gdv5Z = parcelRequire("gdv5Z");
var $1s5hv = parcelRequire("1s5hv");
var $u9agA = parcelRequire("u9agA");
const $0a863c75712dbd4f$var$styles = {
    summaryPopup: "_ca0q1b66 _u5f3u2gc _n3tdu2gc _19bvu2gc _p12foiq5"
};
const $0a863c75712dbd4f$export$55d575bd4bcbc45e = 'render-summary-view-popup';
const $0a863c75712dbd4f$export$d441f1c2eaaec099 = ({ emojiProvider: emojiProvider, reactions: reactions = [], flash: flash = {}, particleEffectByEmoji: particleEffectByEmoji = {}, placement: placement = 'auto-start', onReactionClick: onReactionClick, onReactionFocused: onReactionFocused, onReactionMouseEnter: onReactionMouseEnter, showOpaqueBackground: showOpaqueBackground = false, subtleReactionsSummaryAndPicker: subtleReactionsSummaryAndPicker = false, allowUserDialog: allowUserDialog, handleOpenReactionsDialog: handleOpenReactionsDialog, isViewOnly: isViewOnly = false, allowSelectFromSummaryView: allowSelectFromSummaryView, disabled: disabled, emojiPickerSize: emojiPickerSize, onSelection: onSelection, tooltipContent: tooltipContent, reactionPickerTriggerIcon: reactionPickerTriggerIcon, onOpen: onOpen, useButtonAlignmentStyling: useButtonAlignmentStyling, reactionPickerTriggerText: reactionPickerTriggerText, hoverableSummaryView: hoverableSummaryView = false, hoverableSummaryViewDelay: hoverableSummaryViewDelay = 300, summaryGetOptimisticImageURL: summaryGetOptimisticImageURL, summaryButtonIconAfter: summaryButtonIconAfter, summaryViewParticleEffectEmojiId: summaryViewParticleEffectEmojiId })=>{
    const [isSummaryPopupOpen, setSummaryPopupOpen] = (0, $6tNP7.useDelayedState)(false, hoverableSummaryViewDelay);
    const [isHoveringSummaryView, setIsHoveringSummaryView] = (0, $gwFzn.useState)(false);
    const [isSummaryViewButtonHovered, setIsSummaryViewButtonHovered] = (0, $gwFzn.useState)(false);
    const [isSummaryViewButtonClicked, setIsSummaryViewButtonClicked] = (0, $gwFzn.useState)(false);
    const [isEmojiPickerOpen, setIsEmojiPickerOpen] = (0, $gwFzn.useState)(false);
    /**
   * Event callback when the picker is closed
   * @param _id Optional id if an emoji button was selected or undefined if was clicked outside the picker
   */ const close = (0, $gwFzn.useCallback)((_id)=>{
        setIsEmojiPickerOpen(false);
        // ufo abort reaction experience
        (0, $1x5Ue.PickerRender).abort({
            metadata: {
                emojiId: _id,
                source: 'ReactionPicker',
                reason: 'close dialog'
            }
        });
    }, []);
    /**
   * Event callback when an emoji icon is selected
   * @param item selected item
   */ const onEmojiSelected = (0, $gwFzn.useCallback)((item)=>{
        // no emoji was selected
        if (!item.id) return;
        onSelection(item.id, 'emojiPicker');
        close(item.id);
    }, [
        onSelection,
        close
    ]);
    const handlePopupClose = (0, $gwFzn.useCallback)(()=>{
        setSummaryPopupOpen(false, true);
        setIsEmojiPickerOpen(false);
        setIsSummaryViewButtonClicked(false);
        setIsSummaryViewButtonHovered(false);
        setIsHoveringSummaryView(false);
    }, [
        setSummaryPopupOpen,
        setIsEmojiPickerOpen,
        setIsSummaryViewButtonClicked,
        setIsSummaryViewButtonHovered,
        setIsHoveringSummaryView
    ]);
    const openEmojiPicker = (0, $gwFzn.useCallback)(()=>{
        // ufo start reactions picker open experience
        (0, $1x5Ue.PickerRender).start();
        onOpen && onOpen();
        // ufo reactions picker opened success
        setIsEmojiPickerOpen(true);
        (0, $1x5Ue.PickerRender).success();
    }, [
        onOpen
    ]);
    const handleEmojiPickerTriggerClick = (0, $gwFzn.useCallback)(()=>{
        openEmojiPicker();
        setSummaryPopupOpen(false, true);
        setIsSummaryViewButtonClicked(false);
        setIsSummaryViewButtonHovered(false);
        setIsHoveringSummaryView(false);
    }, [
        openEmojiPicker,
        setSummaryPopupOpen
    ]);
    const handleSummaryClick = (0, $gwFzn.useCallback)(()=>{
        if (hoverableSummaryView) {
            setIsHoveringSummaryView(false);
            setIsSummaryViewButtonHovered(false);
            if (isEmojiPickerOpen || isSummaryViewButtonClicked) {
                // if either the emoji picker is open or the button was clicked, close the popup and reset the state
                setSummaryPopupOpen(false, true);
                setIsSummaryViewButtonClicked(false);
            } else {
                // if neither condition is true, open the popup and set the state
                setSummaryPopupOpen(true, true);
                setIsSummaryViewButtonClicked(true);
            }
            // close the emoji picker
            setIsEmojiPickerOpen(false);
        } else if (isSummaryPopupOpen) handlePopupClose();
        else setSummaryPopupOpen(true);
    }, [
        hoverableSummaryView,
        isEmojiPickerOpen,
        setSummaryPopupOpen,
        isSummaryPopupOpen,
        handlePopupClose,
        isSummaryViewButtonClicked,
        setIsSummaryViewButtonClicked
    ]);
    const handleButtonMouseEnter = (0, $gwFzn.useCallback)(()=>{
        setIsSummaryViewButtonHovered(true);
        if (hoverableSummaryView && !isEmojiPickerOpen) setSummaryPopupOpen(true);
    }, [
        hoverableSummaryView,
        setSummaryPopupOpen,
        setIsSummaryViewButtonHovered,
        isEmojiPickerOpen
    ]);
    const handleButtonMouseLeave = (0, $gwFzn.useCallback)(()=>{
        setIsSummaryViewButtonHovered(false);
        if (hoverableSummaryView && !isHoveringSummaryView && !isSummaryViewButtonClicked) setSummaryPopupOpen(false);
    }, [
        hoverableSummaryView,
        isHoveringSummaryView,
        setSummaryPopupOpen,
        setIsSummaryViewButtonHovered,
        isSummaryViewButtonClicked
    ]);
    const handleSummaryViewTrayMouseEnter = (0, $gwFzn.useCallback)(()=>{
        setIsHoveringSummaryView(true);
        if (hoverableSummaryView && !isEmojiPickerOpen) setSummaryPopupOpen(true);
    }, [
        hoverableSummaryView,
        setSummaryPopupOpen,
        setIsHoveringSummaryView,
        isEmojiPickerOpen
    ]);
    const handleSummaryViewTrayMouseLeave = (0, $gwFzn.useCallback)(()=>{
        setIsHoveringSummaryView(false);
        if (hoverableSummaryView && !isSummaryViewButtonHovered && !isSummaryViewButtonClicked) setSummaryPopupOpen(false);
    }, [
        hoverableSummaryView,
        isSummaryViewButtonHovered,
        setIsHoveringSummaryView,
        setSummaryPopupOpen,
        isSummaryViewButtonClicked
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lGgRw.default), {
        placement: placement,
        content: ({ update: recalculatePopupPosition })=>isEmojiPickerOpen ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lGf1F.default), {
                emojiProvider: emojiProvider,
                onSelection: onEmojiSelected,
                size: emojiPickerSize
            }) : /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gdv5Z.default), {
                testId: $0a863c75712dbd4f$export$55d575bd4bcbc45e,
                onMouseEnter: handleSummaryViewTrayMouseEnter,
                onMouseLeave: handleSummaryViewTrayMouseLeave,
                children: [
                    allowSelectFromSummaryView && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1s5hv.default), {
                        justifyContent: "center",
                        testId: "reaction-summary-view-emoji-picker-container",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gIViu.Trigger), {
                            disabled: disabled,
                            reactionPickerTriggerIcon: reactionPickerTriggerIcon,
                            tooltipContent: tooltipContent,
                            onClick: ()=>{
                                handleEmojiPickerTriggerClick();
                                recalculatePopupPosition();
                            },
                            showAddReactionText: true,
                            reactionPickerTriggerText: reactionPickerTriggerText,
                            fullWidthSummaryViewReactionPickerTrigger: true
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $u9agA.default), {
                        xcss: $0a863c75712dbd4f$var$styles.summaryPopup,
                        space: "space.025",
                        shouldWrap: true,
                        alignBlock: "center",
                        children: reactions.map((reaction)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $3NvVh.Reaction), {
                                reaction: reaction,
                                emojiProvider: emojiProvider,
                                onClick: onReactionClick,
                                onFocused: onReactionFocused,
                                onMouseEnter: onReactionMouseEnter,
                                flash: flash[reaction.emojiId],
                                showParticleEffect: particleEffectByEmoji[reaction.emojiId],
                                allowUserDialog: allowUserDialog,
                                handleOpenReactionsDialog: handleOpenReactionsDialog,
                                isViewOnly: isViewOnly
                            }, reaction.emojiId))
                    })
                ]
            }),
        isOpen: isSummaryPopupOpen || isEmojiPickerOpen,
        onClose: handlePopupClose,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $g5P9l.ReactionSummaryButton), {
                ...triggerProps,
                emojiProvider: emojiProvider,
                reactions: reactions,
                onClick: handleSummaryClick,
                onMouseEnter: handleButtonMouseEnter,
                onMouseLeave: handleButtonMouseLeave,
                showOpaqueBackground: showOpaqueBackground,
                subtleReactionsSummaryAndPicker: subtleReactionsSummaryAndPicker,
                useButtonAlignmentStyling: useButtonAlignmentStyling,
                summaryGetOptimisticImageURL: summaryGetOptimisticImageURL,
                summaryButtonIconAfter: summaryButtonIconAfter,
                summaryViewParticleEffectEmojiId: summaryViewParticleEffectEmojiId
            })
    });
};

});
parcelRegister("g5P9l", function(module, exports) {

$parcel$export(module.exports, "ReactionSummaryButton", () => $080c41fc9f1a0a34$export$cc50c972184463a7);
/* ReactionSummaryButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $etuMO = parcelRequire("etuMO");

var $9G3wK = parcelRequire("9G3wK");

var $dEmEP = parcelRequire("dEmEP");

var $lmASn = parcelRequire("lmASn");

var $gGaVB = parcelRequire("gGaVB");

var $boQXV = parcelRequire("boQXV");

var $gdv5Z = parcelRequire("gdv5Z");
var $1s5hv = parcelRequire("1s5hv");
var $u9agA = parcelRequire("u9agA");
var $eyWa4 = parcelRequire("eyWa4");

var $ddbVR = parcelRequire("ddbVR");
const $080c41fc9f1a0a34$var$styles = {
    emoji: "_8hrz1nam",
    button: "_ca0q1b66 _u5f31b66 _n3td1b66 _19bvu2gc",
    container: "_kqswh2mm",
    summaryButtonIconAfter: "_u5f3u2gc _1e0c1txw _4cvr1h6o _1bah1h6o",
    particleEffectContainer: "_u5f31ejb"
};
const $080c41fc9f1a0a34$export$bf8263842b2b0eb6 = 'reaction-summary-button'; /**
                                                                        * Test id for emojis displayed inside summary button. All emoji's in the summary button will have this test id
                                                                        */ 
const $080c41fc9f1a0a34$export$6adb00c908f27fce = 'summary-emoji-display'; // forwardRef is used here so that the parent popup component can properly interact with the button
const $080c41fc9f1a0a34$export$cc50c972184463a7 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ emojiProvider: emojiProvider, reactions: reactions = [], emojisToShow: emojisToShow = 3, onClick: onClick, showOpaqueBackground: showOpaqueBackground = false, subtleReactionsSummaryAndPicker: subtleReactionsSummaryAndPicker = false, useButtonAlignmentStyling: useButtonAlignmentStyling = false, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, summaryGetOptimisticImageURL: summaryGetOptimisticImageURL, summaryButtonIconAfter: summaryButtonIconAfter, summaryViewParticleEffectEmojiId: summaryViewParticleEffectEmojiId }, ref)=>{
    const intl = (0, $dBxQj.default)(); // Helper function to sort reactions by count and return top N
    const getTopReactions = (reactions, topN)=>{
        return [
            ...reactions
        ].sort((a, b)=>b.count - a.count).slice(0, topN);
    };
    const totalReactionsCount = (0, $gwFzn.useMemo)(()=>{
        return reactions.reduce((accum, current)=>{
            return accum += current?.count || 0;
        }, 0);
    }, [
        reactions
    ]);
    const topReactions = (0, $gwFzn.useMemo)(()=>getTopReactions(reactions, emojisToShow), [
        emojisToShow,
        reactions
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1s5hv.default), {
        xcss: $080c41fc9f1a0a34$var$styles.container,
        ref: ref,
        alignItems: "center",
        justifyContent: "center",
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $eyWa4.default), {
            alignInline: "center",
            children: [
                summaryViewParticleEffectEmojiId && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                    xcss: $080c41fc9f1a0a34$var$styles.particleEffectContainer,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $boQXV.ReactionParticleEffect), {
                        emojiId: summaryViewParticleEffectEmojiId,
                        emojiProvider: emojiProvider
                    }, summaryViewParticleEffectEmojiId.id)
                }),
                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gGaVB.ReactionButton), {
                    onClick: onClick,
                    onMouseEnter: onMouseEnter,
                    onMouseLeave: onMouseLeave,
                    testId: $080c41fc9f1a0a34$export$bf8263842b2b0eb6,
                    ariaLabel: intl.formatMessage((0, $9G3wK.messages).summary),
                    showSubtleStyle: subtleReactionsSummaryAndPicker,
                    showOpaqueBackground: showOpaqueBackground,
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $u9agA.default), {
                            space: "space.050",
                            xcss: (0, $ddbVR.cx)($080c41fc9f1a0a34$var$styles.button),
                            testId: "reaction-summary-wrapper",
                            children: topReactions.map((reaction)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                                    xcss: $080c41fc9f1a0a34$var$styles.emoji,
                                    testId: $080c41fc9f1a0a34$export$6adb00c908f27fce,
                                    style: {
                                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography
                                        lineHeight: '12px'
                                    },
                                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $etuMO.default), {
                                        emojiProvider: emojiProvider,
                                        emojiId: {
                                            id: reaction.emojiId,
                                            shortName: ''
                                        },
                                        fitToHeight: (0, $dEmEP.RESOURCED_EMOJI_COMPACT_HEIGHT),
                                        optimisticImageURL: summaryGetOptimisticImageURL?.(reaction.emojiId)
                                    }, reaction.emojiId)
                                }))
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lmASn.Counter), {
                            value: totalReactionsCount,
                            useDarkerFont: useButtonAlignmentStyling,
                            useUpdatedStyles: useButtonAlignmentStyling
                        }),
                        summaryButtonIconAfter && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                            xcss: $080c41fc9f1a0a34$var$styles.summaryButtonIconAfter,
                            children: summaryButtonIconAfter
                        })
                    ]
                })
            ]
        })
    });
});

});




//# sourceMappingURL=render.5c605e50.js.map
